import { __decorate } from 'tslib';
import { Injectable, EventEmitter, Renderer2, Input, Output, ViewChild, Component, forwardRef, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopoverConfig, PopoverModule } from 'ngx-bootstrap/popover';
import { HttpRequest, HttpClient, HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { faHeading, faBold, faItalic, faUnderline, faStrikethrough, faSuperscript, faSubscript, faFont, faTextHeight, faTint, faAlignLeft, faAlignCenter, faAlignRight, faAlignJustify, faIndent, faOutdent, faCut, faEraser, faUndo, faRedo, faParagraph, faQuoteLeft, faQuoteRight, faMinus, faListUl, faListOl, faLink, faUnlink, faFileUpload } from '@fortawesome/free-solid-svg-icons';
import { faCopy, faTrashAlt, faImage } from '@fortawesome/free-regular-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
 * enable or disable toolbar based on configuration
 *
 * @param value toolbar item
 * @param toolbar toolbar configuration object
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ngx-bootstrap/popover';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@fortawesome/angular-fontawesome';

const _c0 = ["ngxTextArea"];
const _c1 = ["ngxWrapper"];
function NgxTextEditorComponent_ngx_grippie_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngx-grippie");
} }
function NgxTextEditorMessageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("dblclick", function NgxTextEditorMessageComponent_div_0_Template_div_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.clearMessage()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.ngxMessage, "\n");
} }
const _c2 = ["urlPopover"];
const _c3 = ["imagePopover"];
const _c4 = ["videoPopover"];
const _c5 = ["fontSizePopover"];
const _c6 = ["colorPopover"];
function NgxTextEditorToolbarComponent_div_0_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r48); const ctx_r47 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r47.toggleHeading("h1")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3, "1");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r13.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r13.icons.heading);
} }
function NgxTextEditorToolbarComponent_div_0_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r49 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r49.toggleHeading("h2")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3, "2");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r14.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r14.icons.heading);
} }
function NgxTextEditorToolbarComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r52 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 19);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r52); const ctx_r51 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r51.toggleHeading("h3")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3, "3");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r15.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r15.icons.heading);
} }
function NgxTextEditorToolbarComponent_div_0_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r54 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r53 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r53.triggerCommand("bold")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r16.config.toolbarTitle["bold"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r16.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r16.icons.bold);
} }
function NgxTextEditorToolbarComponent_div_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r56 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r55 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r55.triggerCommand("italic")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r17.config.toolbarTitle["italic"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r17.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r17.icons.italic);
} }
function NgxTextEditorToolbarComponent_div_0_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r58 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r58); const ctx_r57 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r57.triggerCommand("underline")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r18.config.toolbarTitle["underline"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r18.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r18.icons.underline);
} }
function NgxTextEditorToolbarComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r60 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r59 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r59.triggerCommand("strikeThrough")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r19.config.toolbarTitle["strikeThrough"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r19.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r19.icons.strikethrough);
} }
function NgxTextEditorToolbarComponent_div_0_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r62 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r62); const ctx_r61 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r61.triggerCommand("superscript")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r20.config.toolbarTitle["superscript"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r20.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r20.icons.superscript);
} }
function NgxTextEditorToolbarComponent_div_0_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r64 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r64); const ctx_r63 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r63.triggerCommand("subscript")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r21.config.toolbarTitle["subscript"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r21.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r21.icons.subscript);
} }
function NgxTextEditorToolbarComponent_div_0_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21, 22);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r67); const ctx_r66 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r66.fontName = ""); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(12);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r22.config.toolbarTitle["fontName"]);
    ɵngcc0.ɵɵproperty("popover", _r11)("disabled", !ctx_r22.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r22.icons.font);
} }
function NgxTextEditorToolbarComponent_div_0_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r70 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21, 23);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r70); const ctx_r69 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r69.fontSize = ""); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    const _r9 = ɵngcc0.ɵɵreference(10);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r23.config.toolbarTitle["fontSize"]);
    ɵngcc0.ɵɵproperty("popover", _r9)("disabled", !ctx_r23.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r23.icons.textheight);
} }
function NgxTextEditorToolbarComponent_div_0_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r73 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21, 24);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_14_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r72 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r72.hexColor = ""); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    const _r7 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r24.config.toolbarTitle["color"]);
    ɵngcc0.ɵɵproperty("popover", _r7)("disabled", !ctx_r24.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r24.icons.tint);
} }
function NgxTextEditorToolbarComponent_div_0_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r75 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_16_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r75); const ctx_r74 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r74.triggerCommand("justifyLeft")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r25.config.toolbarTitle["justifyLeft"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r25.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r25.icons.alignleft);
} }
function NgxTextEditorToolbarComponent_div_0_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r77 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_17_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r77); const ctx_r76 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r76.triggerCommand("justifyCenter")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r26.config.toolbarTitle["justifyCenter"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r26.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r26.icons.aligncenter);
} }
function NgxTextEditorToolbarComponent_div_0_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r79 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_18_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r79); const ctx_r78 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r78.triggerCommand("justifyRight")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r27.config.toolbarTitle["justifyRight"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r27.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r27.icons.alignright);
} }
function NgxTextEditorToolbarComponent_div_0_button_19_Template(rf, ctx) { if (rf & 1) {
    const _r81 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_19_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r81); const ctx_r80 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r80.triggerCommand("justifyFull")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r28.config.toolbarTitle["justifyFull"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r28.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r28.icons.alignjustify);
} }
function NgxTextEditorToolbarComponent_div_0_button_20_Template(rf, ctx) { if (rf & 1) {
    const _r83 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_20_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r82 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r82.triggerCommand("indent")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r29.config.toolbarTitle["indent"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r29.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r29.icons.indent);
} }
function NgxTextEditorToolbarComponent_div_0_button_21_Template(rf, ctx) { if (rf & 1) {
    const _r85 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_21_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r85); const ctx_r84 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r84.triggerCommand("outdent")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r30.config.toolbarTitle["outdent"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r30.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r30.icons.outdent);
} }
function NgxTextEditorToolbarComponent_div_0_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r87 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_23_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r87); const ctx_r86 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r86.triggerCommand("cut")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r31.config.toolbarTitle["cut"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r31.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r31.icons.scissors);
} }
function NgxTextEditorToolbarComponent_div_0_button_24_Template(rf, ctx) { if (rf & 1) {
    const _r89 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_24_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r89); const ctx_r88 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r88.triggerCommand("copy")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r32.config.toolbarTitle["copy"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r32.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r32.icons.fileso);
} }
function NgxTextEditorToolbarComponent_div_0_button_25_Template(rf, ctx) { if (rf & 1) {
    const _r91 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_25_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r91); const ctx_r90 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r90.triggerCommand("delete")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r33.config.toolbarTitle["delete"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r33.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r33.icons.trash);
} }
function NgxTextEditorToolbarComponent_div_0_button_26_Template(rf, ctx) { if (rf & 1) {
    const _r93 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_26_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r93); const ctx_r92 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r92.triggerCommand("removeFormat")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r34.config.toolbarTitle["removeFormat"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r34.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r34.icons.eraser);
} }
function NgxTextEditorToolbarComponent_div_0_button_27_Template(rf, ctx) { if (rf & 1) {
    const _r95 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_27_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r95); const ctx_r94 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r94.triggerCommand("undo")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r35.config.toolbarTitle["undo"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r35.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r35.icons.undo);
} }
function NgxTextEditorToolbarComponent_div_0_button_28_Template(rf, ctx) { if (rf & 1) {
    const _r97 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_28_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r97); const ctx_r96 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r96.triggerCommand("redo")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r36.config.toolbarTitle["redo"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r36.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r36.icons.repeat);
} }
function NgxTextEditorToolbarComponent_div_0_button_30_Template(rf, ctx) { if (rf & 1) {
    const _r99 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_30_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r99); const ctx_r98 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r98.triggerCommand("insertParagraph")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r37.config.toolbarTitle["paragraph"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r37.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r37.icons.paragraph);
} }
function NgxTextEditorToolbarComponent_div_0_button_31_Template(rf, ctx) { if (rf & 1) {
    const _r101 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_31_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r101); const ctx_r100 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r100.triggerCommand("blockquote")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r38.config.toolbarTitle["blockquote"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r38.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r38.icons.quoteleft);
} }
function NgxTextEditorToolbarComponent_div_0_button_32_Template(rf, ctx) { if (rf & 1) {
    const _r103 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_32_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r103); const ctx_r102 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r102.triggerCommand("removeBlockquote")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r39.config.toolbarTitle["removeBlockquote"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r39.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r39.icons.quoteright);
} }
function NgxTextEditorToolbarComponent_div_0_button_33_Template(rf, ctx) { if (rf & 1) {
    const _r105 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_33_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r105); const ctx_r104 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r104.triggerCommand("insertHorizontalRule")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r40.config.toolbarTitle["horizontalLine"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r40.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r40.icons.minus);
} }
function NgxTextEditorToolbarComponent_div_0_button_34_Template(rf, ctx) { if (rf & 1) {
    const _r107 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_34_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r107); const ctx_r106 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r106.triggerCommand("insertUnorderedList")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r41.config.toolbarTitle["unorderedList"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r41.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r41.icons.listul);
} }
function NgxTextEditorToolbarComponent_div_0_button_35_Template(rf, ctx) { if (rf & 1) {
    const _r109 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_35_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r109); const ctx_r108 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r108.triggerCommand("insertOrderedList")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r42.config.toolbarTitle["orderedList"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r42.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r42.icons.listol);
} }
function NgxTextEditorToolbarComponent_div_0_button_37_Template(rf, ctx) { if (rf & 1) {
    const _r112 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 25, 26);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_37_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r112); const ctx_r111 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r111.buildUrlForm()); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r43.config.toolbarTitle["link"]);
    ɵngcc0.ɵɵproperty("popover", _r1)("disabled", !ctx_r43.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r43.icons.link);
} }
function NgxTextEditorToolbarComponent_div_0_button_38_Template(rf, ctx) { if (rf & 1) {
    const _r114 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_38_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r114); const ctx_r113 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r113.triggerCommand("unlink")); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r44.config.toolbarTitle["unlink"]);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r44.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r44.icons.chainbroken);
} }
function NgxTextEditorToolbarComponent_div_0_button_39_Template(rf, ctx) { if (rf & 1) {
    const _r117 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21, 27);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_39_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r117); const ctx_r116 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r116.buildImageForm()); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r45.config.toolbarTitle["image"]);
    ɵngcc0.ɵɵproperty("popover", _r3)("disabled", !ctx_r45.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r45.icons.pictureo);
} }
function NgxTextEditorToolbarComponent_div_0_button_40_Template(rf, ctx) { if (rf & 1) {
    const _r120 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21, 28);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_div_0_button_40_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r120); const ctx_r119 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r119.buildVideoForm()); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = ɵngcc0.ɵɵnextContext(2);
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r46.config.toolbarTitle["video"]);
    ɵngcc0.ɵɵproperty("popover", _r5)("disabled", !ctx_r46.config["enableToolbar"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r46.icons.youtubeplay);
} }
function NgxTextEditorToolbarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, NgxTextEditorToolbarComponent_div_0_button_2_Template, 4, 2, "button", 9);
    ɵngcc0.ɵɵtemplate(3, NgxTextEditorToolbarComponent_div_0_button_3_Template, 4, 2, "button", 10);
    ɵngcc0.ɵɵtemplate(4, NgxTextEditorToolbarComponent_div_0_button_4_Template, 4, 2, "button", 11);
    ɵngcc0.ɵɵtemplate(5, NgxTextEditorToolbarComponent_div_0_button_5_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(6, NgxTextEditorToolbarComponent_div_0_button_6_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(7, NgxTextEditorToolbarComponent_div_0_button_7_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(8, NgxTextEditorToolbarComponent_div_0_button_8_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(9, NgxTextEditorToolbarComponent_div_0_button_9_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(10, NgxTextEditorToolbarComponent_div_0_button_10_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵtemplate(12, NgxTextEditorToolbarComponent_div_0_button_12_Template, 3, 4, "button", 13);
    ɵngcc0.ɵɵtemplate(13, NgxTextEditorToolbarComponent_div_0_button_13_Template, 3, 4, "button", 13);
    ɵngcc0.ɵɵtemplate(14, NgxTextEditorToolbarComponent_div_0_button_14_Template, 3, 4, "button", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 8);
    ɵngcc0.ɵɵtemplate(16, NgxTextEditorToolbarComponent_div_0_button_16_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(17, NgxTextEditorToolbarComponent_div_0_button_17_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(18, NgxTextEditorToolbarComponent_div_0_button_18_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(19, NgxTextEditorToolbarComponent_div_0_button_19_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(20, NgxTextEditorToolbarComponent_div_0_button_20_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(21, NgxTextEditorToolbarComponent_div_0_button_21_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 8);
    ɵngcc0.ɵɵtemplate(23, NgxTextEditorToolbarComponent_div_0_button_23_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(24, NgxTextEditorToolbarComponent_div_0_button_24_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(25, NgxTextEditorToolbarComponent_div_0_button_25_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(26, NgxTextEditorToolbarComponent_div_0_button_26_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(27, NgxTextEditorToolbarComponent_div_0_button_27_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(28, NgxTextEditorToolbarComponent_div_0_button_28_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 8);
    ɵngcc0.ɵɵtemplate(30, NgxTextEditorToolbarComponent_div_0_button_30_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(31, NgxTextEditorToolbarComponent_div_0_button_31_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(32, NgxTextEditorToolbarComponent_div_0_button_32_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(33, NgxTextEditorToolbarComponent_div_0_button_33_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(34, NgxTextEditorToolbarComponent_div_0_button_34_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(35, NgxTextEditorToolbarComponent_div_0_button_35_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 8);
    ɵngcc0.ɵɵtemplate(37, NgxTextEditorToolbarComponent_div_0_button_37_Template, 3, 4, "button", 14);
    ɵngcc0.ɵɵtemplate(38, NgxTextEditorToolbarComponent_div_0_button_38_Template, 2, 3, "button", 12);
    ɵngcc0.ɵɵtemplate(39, NgxTextEditorToolbarComponent_div_0_button_39_Template, 3, 4, "button", 13);
    ɵngcc0.ɵɵtemplate(40, NgxTextEditorToolbarComponent_div_0_button_40_Template, 3, 4, "button", 13);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("h1"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("h2"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("h3"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("bold"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("italic"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("underline"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("strikeThrough"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("superscript"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("subscript"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("fontName"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("fontSize"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("color"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("justifyLeft"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("justifyCenter"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("justifyRight"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("justifyFull"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("indent"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("outdent"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("cut"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("copy"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("delete"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("removeFormat"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("undo"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("redo"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("paragraph"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("blockquote"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("removeBlockquote"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("horizontalLine"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("unorderedList"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("orderedList"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("link"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("unlink"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("image"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEnableToolbarOptions("video"));
} }
function NgxTextEditorToolbarComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r122 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29)(1, "form", 30);
    ɵngcc0.ɵɵlistener("ngSubmit", function NgxTextEditorToolbarComponent_ng_template_1_Template_form_ngSubmit_1_listener() { ɵngcc0.ɵɵrestoreView(_r122); const ctx_r121 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r121.urlForm.valid && ctx_r121.insertLink()); });
    ɵngcc0.ɵɵelementStart(2, "div", 31)(3, "label", 32);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 31)(7, "label", 34);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "input", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 36);
    ɵngcc0.ɵɵelement(11, "input", 37);
    ɵngcc0.ɵɵelementStart(12, "label", 38);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(14, "button", 39);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r2.urlForm);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.config.toolbarTitle["URLInput"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.config.toolbarTitle["URLInput"]);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.config.toolbarTitle["urlTextInput"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.config.toolbarTitle["urlTextInput"]);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.config.toolbarTitle["urlNewTab"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.config.toolbarTitle["linkSubmit"]);
} }
function NgxTextEditorToolbarComponent_ng_template_3_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function NgxTextEditorToolbarComponent_ng_template_3_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r130 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r130.config.toolbarTitle["chooseImage"]);
} }
function NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p")(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r131 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r131.config.toolbarTitle["uploadingimage"]);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r131.updloadPercentage, " %");
} }
function NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r133 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 48);
    ɵngcc0.ɵɵtemplate(1, NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_p_1_Template, 2, 1, "p", 49);
    ɵngcc0.ɵɵtemplate(2, NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_p_2_Template, 6, 2, "p", 49);
    ɵngcc0.ɵɵelementStart(3, "div", 50)(4, "input", 51);
    ɵngcc0.ɵɵlistener("change", function NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_Template_input_change_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r133); const ctx_r132 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r132.onFileChange($event)); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r126 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r126.uploadComplete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r126.uploadComplete);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("cursor", ctx_r126.isUploading ? "not-allowed" : "allowed");
    ɵngcc0.ɵɵproperty("disabled", ctx_r126.isUploading);
} }
function NgxTextEditorToolbarComponent_ng_template_3_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r135 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 52);
    ɵngcc0.ɵɵlistener("ngSubmit", function NgxTextEditorToolbarComponent_ng_template_3_ng_template_11_Template_form_ngSubmit_0_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r134 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r134.imageForm.valid && ctx_r134.insertImage()); });
    ɵngcc0.ɵɵelementStart(1, "div", 31)(2, "label", 53);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 39);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r128 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r128.imageForm);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r128.config.toolbarTitle["imageURLInput"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r128.config.toolbarTitle["imageURLInput"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r128.config.toolbarTitle["imageSubmit"]);
} }
const _c7 = function (a0, a1, a2) { return { "bg-danger": a0, "bg-warning": a1, "bg-success": a2 }; };
function NgxTextEditorToolbarComponent_ng_template_3_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 55);
    ɵngcc0.ɵɵelement(1, "div", 56);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r129 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ctx_r129.updloadPercentage, "%");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(3, _c7, ctx_r129.updloadPercentage < 20, ctx_r129.updloadPercentage < 50, ctx_r129.updloadPercentage >= 100));
} }
const _c8 = function (a0) { return { active: a0 }; };
function NgxTextEditorToolbarComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r137 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 40)(1, "div", 41)(2, "button", 42);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_3_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r137); const ctx_r136 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r136.isImageUploader = true); });
    ɵngcc0.ɵɵelement(3, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 42);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_3_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r137); const ctx_r138 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r138.isImageUploader = false); });
    ɵngcc0.ɵɵelement(5, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 43);
    ɵngcc0.ɵɵtemplate(7, NgxTextEditorToolbarComponent_ng_template_3_div_7_Template, 1, 0, "div", 44);
    ɵngcc0.ɵɵtemplate(8, NgxTextEditorToolbarComponent_ng_template_3_div_8_Template, 1, 0, "div", 44);
    ɵngcc0.ɵɵtemplate(9, NgxTextEditorToolbarComponent_ng_template_3_ng_template_9_Template, 5, 5, "ng-template", null, 45, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(11, NgxTextEditorToolbarComponent_ng_template_3_ng_template_11_Template, 7, 4, "ng-template", null, 46, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(13, NgxTextEditorToolbarComponent_ng_template_3_div_13_Template, 2, 7, "div", 47);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r125 = ɵngcc0.ɵɵreference(10);
    const _r127 = ɵngcc0.ɵɵreference(12);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c8, ctx_r4.isImageUploader));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r4.icons.upload);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c8, !ctx_r4.isImageUploader));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r4.icons.link);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.isImageUploader)("ngIfElse", _r127);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.isImageUploader)("ngIfElse", _r125);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.uploadComplete);
} }
function NgxTextEditorToolbarComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r140 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 40)(1, "div", 41)(2, "button", 57);
    ɵngcc0.ɵɵelement(3, "fa-icon", 16);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 43)(5, "form", 52);
    ɵngcc0.ɵɵlistener("ngSubmit", function NgxTextEditorToolbarComponent_ng_template_5_Template_form_ngSubmit_5_listener() { ɵngcc0.ɵɵrestoreView(_r140); const ctx_r139 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r139.videoForm.valid && ctx_r139.insertVideo()); });
    ɵngcc0.ɵɵelementStart(6, "div", 31)(7, "label", 58);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "input", 59);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 60)(11, "div", 61);
    ɵngcc0.ɵɵelement(12, "input", 62);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 61);
    ɵngcc0.ɵɵelement(14, "input", 63);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "label", 64);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(17, "button", 39);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("icon", ctx_r6.icons.link);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r6.videoForm);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.config.toolbarTitle["videoURLInput"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r6.config.toolbarTitle["videoURLInput"]);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r6.config.toolbarTitle["height"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r6.config.toolbarTitle["width"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.config.toolbarTitle["heightwidth"]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.config.toolbarTitle["videoSubmit"]);
} }
function NgxTextEditorToolbarComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r142 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 40)(1, "div", 65)(2, "span", 66);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_7_Template_span_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r142); const ctx_r141 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r141.selectedColorTab = "textColor"); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 66);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_7_Template_span_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r142); const ctx_r143 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r143.selectedColorTab = "backgroundColor"); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 67)(7, "form", 68)(8, "div", 31)(9, "label", 69);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "input", 70);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxTextEditorToolbarComponent_ng_template_7_Template_input_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r142); const ctx_r144 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r144.hexColor = $event); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(12, "button", 71);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_7_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r142); const ctx_r145 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r145.insertColor(ctx_r145.hexColor, ctx_r145.selectedColorTab)); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c8, ctx_r8.selectedColorTab === "textColor"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.config.toolbarTitle["textColor"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c8, ctx_r8.selectedColorTab === "backgroundColor"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.config.toolbarTitle["backgroundColor"]);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.config.toolbarTitle["hexInput"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r8.config.toolbarTitle["hexInput"]);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.hexColor);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.config.toolbarTitle["hexSubmit"]);
} }
function NgxTextEditorToolbarComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r147 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 72)(1, "form", 68)(2, "div", 31)(3, "label", 73);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 74);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxTextEditorToolbarComponent_ng_template_9_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r147); const ctx_r146 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r146.fontSize = $event); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "button", 71);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_9_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r147); const ctx_r148 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r148.setFontSize(ctx_r148.fontSize)); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.config.toolbarTitle["fontSize"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("placeholder", "", ctx_r10.config.toolbarTitle["fontSize"], " (px/rem)");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r10.fontSize);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.config.toolbarTitle["fontSubmit"]);
} }
function NgxTextEditorToolbarComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r150 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 72)(1, "form", 68)(2, "div", 31)(3, "label", 73);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 75);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxTextEditorToolbarComponent_ng_template_11_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r150); const ctx_r149 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r149.fontName = $event); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "button", 71);
    ɵngcc0.ɵɵlistener("click", function NgxTextEditorToolbarComponent_ng_template_11_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r150); const ctx_r151 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r151.setFontName(ctx_r151.fontName)); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r12.config.toolbarTitle["fontName"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("placeholder", "", ctx_r12.config.toolbarTitle["example"], " 'Times New Roman', Times, serif");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.fontName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r12.config.toolbarTitle["fontSubmit"]);
} }
function canEnableToolbarOptions(value, toolbar) {
    if (value) {
        if (toolbar['length'] === 0) {
            return true;
        }
        else {
            const found = toolbar.filter(array => {
                return array.indexOf(value) !== -1;
            });
            return !!found.length;
        }
    }
    else {
        return false;
    }
}
/**
 * set editor configuration
 *
 * @param value configuration via [config] propertyify
 * @param ngxTextEditorConfig default editor configuration
 * @param input direct configuration inputs via directives
 */
function getEditorConfiguration(value, ngxTextEditorConfig, input) {
    for (const i in ngxTextEditorConfig) {
        if (i) {
            if (input[i] !== undefined) {
                value[i] = input[i];
            }
            if (!value.hasOwnProperty(i)) {
                value[i] = ngxTextEditorConfig[i];
            }
        }
    }
    return value;
}
/**
 * return vertical if the element is the resizer property is set to basic
 *
 * @param resizer type of resizer, either basic or stack
 */
function canResize(resizer) {
    if (resizer === 'basic') {
        return 'vertical';
    }
    return false;
}
/**
 * save selection when the editor is focussed out
 */
function saveSelection() {
    if (window.getSelection) {
        const sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            return sel.getRangeAt(0);
        }
    }
    else if (document.getSelection && document.createRange) {
        return document.createRange();
    }
    return null;
}
/**
 * restore selection when the editor is focussed in
 *
 * @param range saved selection when the editor is focussed out
 */
function restoreSelection(range) {
    if (range) {
        if (window.getSelection) {
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            return true;
        }
        else if (document.getSelection && range.select) {
            range.select();
            return true;
        }
    }
    else {
        return false;
    }
}

var Utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    canEnableToolbarOptions: canEnableToolbarOptions,
    getEditorConfiguration: getEditorConfiguration,
    canResize: canResize,
    saveSelection: saveSelection,
    restoreSelection: restoreSelection
});

let CommandExecutorService = class CommandExecutorService {
    /**
     *
     * @param _http HTTP Client for making http requests
     */
    constructor(_http) {
        this._http = _http;
        /** saves the selection from the editor when focused out */
        this.savedSelection = undefined;
    }
    /**
     * executes command from the toolbar
     *
     * @param command command to be executed
     */
    execute(command) {
        if (!this.savedSelection && command !== 'enableObjectResizing') {
            throw new Error('Range out of Editor');
        }
        if (command === 'enableObjectResizing') {
            document.execCommand('enableObjectResizing', true);
        }
        if (command === 'blockquote') {
            document.execCommand('formatBlock', false, 'blockquote');
        }
        if (command === 'removeBlockquote') {
            document.execCommand('formatBlock', false, 'div');
        }
        if (command === 'h1') {
            document.execCommand('formatBlock', false, 'h1');
        }
        if (command === 'h2') {
            document.execCommand('formatBlock', false, 'h2');
        }
        if (command === 'h3') {
            document.execCommand('formatBlock', false, 'h3');
        }
        if (command === 'clear') {
            document.execCommand('formatBlock', false, 'div');
        }
        document.execCommand(command, false, null);
    }
    /**
     * inserts image in the editor
     *
     * @param imageURI url of the image to be inserted
     */
    insertImage(imageURI) {
        if (this.savedSelection) {
            if (imageURI) {
                const restored = restoreSelection(this.savedSelection);
                if (restored) {
                    const img = document.createElement('img');
                    img.src = imageURI;
                    img.style.width = 'auto';
                    const inserted = this.insertHtml(img.outerHTML);
                    if (!inserted) {
                        throw new Error('Invalid URL');
                    }
                }
            }
        }
        else {
            throw new Error('Range out of the editor');
        }
    }
    /**
   * inserts image in the editor
   *
   * @param videParams url of the image to be inserted
   */
    insertVideo(videParams) {
        if (this.savedSelection) {
            if (videParams) {
                const restored = restoreSelection(this.savedSelection);
                if (restored) {
                    if (this.isYoutubeLink(videParams.videoUrl)) {
                        const youtubeURL = '<iframe width="' + videParams.width + '" height="' + videParams.height + '"'
                            + 'src="' + videParams.videoUrl + '"></iframe>';
                        this.insertHtml(youtubeURL);
                    }
                    else if (this.checkTagSupportInBrowser('video')) {
                        if (this.isValidURL(videParams.videoUrl)) {
                            const videoSrc = '<video width="' + videParams.width + '" height="' + videParams.height + '"'
                                + ' controls="true"><source src="' + videParams.videoUrl + '"></video>';
                            this.insertHtml(videoSrc);
                        }
                        else {
                            throw new Error('Invalid video URL');
                        }
                    }
                    else {
                        throw new Error('Unable to insert video');
                    }
                }
            }
        }
        else {
            throw new Error('Range out of the editor');
        }
    }
    /**
     * checks the input url is a valid youtube URL or not
     *
     * @param url Youtue URL
     */
    isYoutubeLink(url) {
        const ytRegExp = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
        return ytRegExp.test(url);
    }
    /**
     * check whether the string is a valid url or not
     * @param url url
     */
    isValidURL(url) {
        const urlRegExp = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        return urlRegExp.test(url);
    }
    /**
     * uploads image to the server
     *
     * @param file file that has to be uploaded
     * @param endPoint enpoint to which the image has to be uploaded
     */
    uploadImage(file, endPoint) {
        if (!endPoint) {
            throw new Error('Image Endpoint isn`t provided or invalid');
        }
        const formData = new FormData();
        if (file) {
            formData.append('file', file);
            const req = new HttpRequest('POST', endPoint, formData, {
                reportProgress: true
            });
            return this._http.request(req);
        }
        else {
            throw new Error('Invalid Image');
        }
    }
    /**
     * inserts link in the editor
     *
     * @param params parameters that holds the information for the link
     */
    createLink(params) {
        if (this.savedSelection) {
            /**
             * check whether the saved selection contains a range or plain selection
             */
            if (params.urlNewTab) {
                const newUrl = '<a href="' + params.urlLink + '" target="_blank">' + params.urlText + '</a>';
                if (document.getSelection().type !== 'Range') {
                    const restored = restoreSelection(this.savedSelection);
                    if (restored) {
                        this.insertHtml(newUrl);
                    }
                }
                else {
                    throw new Error('Only new links can be inserted. You cannot edit URL`s');
                }
            }
            else {
                const restored = restoreSelection(this.savedSelection);
                if (restored) {
                    document.execCommand('createLink', false, params.urlLink);
                }
            }
        }
        else {
            throw new Error('Range out of the editor');
        }
    }
    /**
     * insert color either font or background
     *
     * @param color color to be inserted
     * @param where where the color has to be inserted either text/background
     */
    insertColor(color, where) {
        if (this.savedSelection) {
            const restored = restoreSelection(this.savedSelection);
            if (restored && this.checkSelection()) {
                if (where === 'textColor') {
                    document.execCommand('foreColor', false, color);
                }
                else {
                    document.execCommand('hiliteColor', false, color);
                }
            }
        }
        else {
            throw new Error('Range out of the editor');
        }
    }
    /**
     * set font size for text
     *
     * @param fontSize font-size to be set
     */
    setFontSize(fontSize) {
        if (this.savedSelection && this.checkSelection()) {
            const deletedValue = this.deleteAndGetElement();
            if (deletedValue) {
                const restored = restoreSelection(this.savedSelection);
                if (restored) {
                    if (this.isNumeric(fontSize)) {
                        const fontPx = '<span style="font-size: ' + fontSize + 'px;">' + deletedValue + '</span>';
                        this.insertHtml(fontPx);
                    }
                    else {
                        const fontPx = '<span style="font-size: ' + fontSize + ';">' + deletedValue + '</span>';
                        this.insertHtml(fontPx);
                    }
                }
            }
        }
        else {
            throw new Error('Range out of the editor');
        }
    }
    /**
     * set font name/family for text
     *
     * @param fontName font-family to be set
     */
    setFontName(fontName) {
        if (this.savedSelection && this.checkSelection()) {
            const deletedValue = this.deleteAndGetElement();
            if (deletedValue) {
                const restored = restoreSelection(this.savedSelection);
                if (restored) {
                    if (this.isNumeric(fontName)) {
                        const fontFamily = '<span style="font-family: ' + fontName + 'px;">' + deletedValue + '</span>';
                        this.insertHtml(fontFamily);
                    }
                    else {
                        const fontFamily = '<span style="font-family: ' + fontName + ';">' + deletedValue + '</span>';
                        this.insertHtml(fontFamily);
                    }
                }
            }
        }
        else {
            throw new Error('Range out of the editor');
        }
    }
    /** insert HTML */
    insertHtml(html) {
        const isHTMLInserted = document.execCommand('insertHTML', false, html);
        if (!isHTMLInserted) {
            throw new Error('Unable to perform the operation');
        }
        return isHTMLInserted;
    }
    /**
     * check whether the value is a number or string
     * if number return true
     * else return false
     */
    isNumeric(value) {
        return /^-{0,1}\d+$/.test(value);
    }
    /** delete the text at selected range and return the value */
    deleteAndGetElement() {
        let slectedText;
        if (this.savedSelection) {
            slectedText = this.savedSelection.toString();
            this.savedSelection.deleteContents();
            return slectedText;
        }
        return false;
    }
    /** check any slection is made or not */
    checkSelection() {
        const slectedText = this.savedSelection.toString();
        if (slectedText.length === 0) {
            throw new Error('No Selection Made');
        }
        return true;
    }
    /**
     * check tag is supported by browser or not
     *
     * @param tag HTML tag
     */
    checkTagSupportInBrowser(tag) {
        return !(document.createElement(tag) instanceof HTMLUnknownElement);
    }
};
CommandExecutorService.ɵfac = function CommandExecutorService_Factory(t) { return new (t || CommandExecutorService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
CommandExecutorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CommandExecutorService, factory: function (t) { return CommandExecutorService.ɵfac(t); } });
CommandExecutorService.ctorParameters = () => [
    { type: HttpClient }
];

/** time in which the message has to be cleared */
const DURATION = 7000;
let MessageService = class MessageService {
    constructor() {
        /** variable to hold the user message */
        this.message = new Subject();
    }
    /** returns the message sent by the editor */
    getMessage() {
        return this.message.asObservable();
    }
    /**
     * sends message to the editor
     *
     * @param message message to be sent
     */
    sendMessage(message) {
        this.message.next(message);
        this.clearMessageIn(DURATION);
    }
    /**
     * a short interval to clear message
     *
     * @param milliseconds time in seconds in which the message has to be cleared
     */
    clearMessageIn(milliseconds) {
        setTimeout(() => {
            this.message.next(undefined);
        }, milliseconds);
    }
};
MessageService.ɵfac = function MessageService_Factory(t) { return new (t || MessageService)(); };
MessageService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MessageService, factory: function (t) { return MessageService.ɵfac(t); } });

/**
 * toolbar default configuration
 */
const ngxTextEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    imageEndPoint: '',
    toolbar: [
        ['h1', 'h2', 'h3', 'bold', 'italic', 'underline', 'strikeThrough', 'superscript', 'subscript'],
        ['fontName', 'fontSize', 'color'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
        ['cut', 'copy', 'delete', 'removeFormat', 'undo', 'redo'],
        ['paragraph', 'blockquote', 'removeBlockquote', 'horizontalLine', 'orderedList', 'unorderedList'],
        ['link', 'unlink', 'image', 'video']
    ],
    toolbarTitle: {
        'bold': 'Bold',
        'italic': 'Italic',
        'underline': 'Underline',
        'strikeThrough': 'strikeThrough',
        'superscript': 'Superscript',
        'subscript': 'Subscript',
        'fontName': 'Font Family',
        'fontSize': 'Font Size',
        'color': 'Color Picker',
        'justifyLeft': 'Justify Left',
        'justifyCenter': 'Justify Center',
        'justifyRight': 'Justify Right',
        'justifyFull': 'Justify Full',
        'indent': 'Indent',
        'outdent': 'Outdent',
        'cut': 'Cut',
        'copy': 'Copy',
        'delete': 'Delete',
        'removeFormat': 'Clear Formatting',
        'undo': 'Undo',
        'redo': 'Redo',
        'paragraph': 'Paragraph',
        'blockquote': 'Blockquote',
        'removeBlockquote': 'Remove Blockquote',
        'horizontalLine': 'Horizontal Line',
        'orderedList': 'Ordered List',
        'unorderedList': 'Color Picker',
        'link': 'Insert Link',
        'URLInput': 'URL',
        'urlTextInput': 'Text',
        'urlNewTab': 'Open in new tab',
        'linkSubmit': 'Submit',
        'unlink': 'Unlink',
        'image': 'Insert Image',
        'chooseImage': 'Choose Image',
        'uploadingimage': 'Uploading Image',
        'imageURLInput': 'URL',
        'imageSubmit': 'Submit',
        'video': 'Insert Video',
        'videoURLInput': 'URL',
        'height': 'height (px)',
        'width': 'width (px)',
        'heightwidth': 'Height/Width',
        'videoSubmit': 'Submit',
        'textColor': 'Text',
        'backgroundColor': 'Background',
        'hexInput': 'Hex Color',
        'hexSubmit': 'Submit',
        'fontSubmit': 'Submit',
        'example': 'Ex:'
    }
};

var NgxTextEditorComponent_1;
let NgxTextEditorComponent = NgxTextEditorComponent_1 = class NgxTextEditorComponent {
    /**
     * @param _messageService service to send message to the editor message component
     * @param _commandExecutor executes command from the toolbar
     * @param _renderer access and manipulate the dom element
     */
    constructor(_messageService, _commandExecutor, _renderer) {
        this._messageService = _messageService;
        this._commandExecutor = _commandExecutor;
        this._renderer = _renderer;
        /**
         * The editor can be resized vertically.
         *
         * `basic` resizer enables the html5 reszier. Check here https://www.w3schools.com/cssref/css3_pr_resize.asp
         *
         * `stack` resizer enable a resizer that looks like as if in https://stackoverflow.com
         */
        this.resizer = 'stack';
        /**
         * The config property is a JSON object
         *
         * All avaibale inputs inputs can be provided in the configuration as JSON
         * inputs provided directly are considered as top priority
         */
        this.config = ngxTextEditorConfig;
        /** emits `blur` event when focused out from the textarea */
        this.blur = new EventEmitter();
        /** emits `focus` event when focused in to the textarea */
        this.focus = new EventEmitter();
        /** emits `uploadImage` event when image is selected */
        this.uploadImage = new EventEmitter();
        this.Utils = Utils;
    }
    /**
     * events
     */
    onTextAreaFocus() {
        this.focus.emit('focus');
    }
    /** focus the text area when the editor is focussed */
    onEditorFocus() {
        this.textArea.nativeElement.focus();
    }
    /**
     * Executed from the contentEditable section while the input property changes
     * @param innerHTML html string from contentEditable
     */
    onContentChange(innerHTML) {
        if (typeof this.onChange === 'function') {
            this.onChange(innerHTML);
            this.togglePlaceholder(innerHTML);
        }
    }
    onTextAreaBlur() {
        /** save selection if focussed out */
        this._commandExecutor.savedSelection = saveSelection();
        if (typeof this.onTouched === 'function') {
            this.onTouched();
        }
        this.blur.emit('blur');
    }
    /**
     * Executed when the image from the disc is selected
     * @param image uploaded file object
     */
    onUploadImage(image) {
        this.uploadImage.emit(image);
    }
    /**
     * resizing text area
     *
     * @param offsetY vertical height of the eidtable portion of the editor
     */
    resizeTextArea(offsetY) {
        let newHeight = parseInt(this.height, 10);
        newHeight += offsetY;
        this.height = newHeight + 'px';
        this.textArea.nativeElement.style.height = this.height;
    }
    /**
     * editor actions, i.e., executes command from toolbar
     *
     * @param commandName name of the command to be executed
     */
    executeCommand(commandName) {
        try {
            this._commandExecutor.execute(commandName);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
    }
    /**
     * Write a new value to the element.
     *
     * @param value value to be executed when there is a change in contenteditable
     */
    writeValue(value) {
        this.togglePlaceholder(value);
        if (value === null || value === undefined || value === '' || value === '<br>') {
            value = null;
        }
        this.refreshView(value);
    }
    /**
     * Set the function to be called
     * when the control receives a change event.
     *
     * @param fn a function
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Set the function to be called
     * when the control receives a touch event.
     *
     * @param fn a function
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * refresh view/HTML of the editor
     *
     * @param value html string from the editor
     */
    refreshView(value) {
        const normalizedValue = value === null ? '' : value;
        this._renderer.setProperty(this.textArea.nativeElement, 'innerHTML', normalizedValue);
    }
    /**
     * toggles placeholder based on input string
     *
     * @param value A HTML string from the editor
     */
    togglePlaceholder(value) {
        if (!value || value === '<br>' || value === '') {
            this._renderer.addClass(this.ngxWrapper.nativeElement, 'show-placeholder');
        }
        else {
            this._renderer.removeClass(this.ngxWrapper.nativeElement, 'show-placeholder');
        }
    }
    /**
     * returns a json containing input params
     */
    getCollectiveParams() {
        return {
            editable: this.editable,
            spellcheck: this.spellcheck,
            placeholder: this.placeholder,
            translate: this.translate,
            height: this.height,
            minHeight: this.minHeight,
            width: this.width,
            minWidth: this.minWidth,
            enableToolbar: this.enableToolbar,
            showToolbar: this.showToolbar,
            imageEndPoint: this.imageEndPoint,
            toolbar: this.toolbar
        };
    }
    ngOnInit() {
        /**
         * set configuration
         */
        this.config = this.Utils.getEditorConfiguration(this.config, ngxTextEditorConfig, this.getCollectiveParams());
        this.height = this.height || this.textArea.nativeElement.offsetHeight;
        this.executeCommand('enableObjectResizing');
    }
};
NgxTextEditorComponent.ɵfac = function NgxTextEditorComponent_Factory(t) { return new (t || NgxTextEditorComponent)(ɵngcc0.ɵɵdirectiveInject(MessageService), ɵngcc0.ɵɵdirectiveInject(CommandExecutorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NgxTextEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxTextEditorComponent, selectors: [["ngx-text-editor"]], viewQuery: function NgxTextEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textArea = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngxWrapper = _t.first);
    } }, inputs: { resizer: "resizer", config: "config", height: "height", editable: "editable", spellcheck: "spellcheck", placeholder: "placeholder", translate: "translate", minHeight: "minHeight", width: "width", minWidth: "minWidth", toolbar: "toolbar", showToolbar: "showToolbar", enableToolbar: "enableToolbar", imageEndPoint: "imageEndPoint" }, outputs: { blur: "blur", focus: "focus", uploadImage: "uploadImage" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NgxTextEditorComponent_1),
                multi: true
            }])], decls: 10, vars: 16, consts: [["id", "ngxTextEditor", "tabindex", "0", 1, "ngx-text-editor", 3, "focus"], [3, "config", "execute", "uploadImage"], [1, "ngx-wrapper"], ["ngxWrapper", ""], [1, "ngx-text-editor-textarea", 3, "input", "focus", "blur"], ["ngxTextArea", ""], [1, "ngx-text-editor-placeholder"], [4, "ngIf"]], template: function NgxTextEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("focus", function NgxTextEditorComponent_Template_div_focus_0_listener() { return ctx.onEditorFocus(); });
        ɵngcc0.ɵɵelementStart(1, "ngx-text-editor-toolbar", 1);
        ɵngcc0.ɵɵlistener("execute", function NgxTextEditorComponent_Template_ngx_text_editor_toolbar_execute_1_listener($event) { return ctx.executeCommand($event); })("uploadImage", function NgxTextEditorComponent_Template_ngx_text_editor_toolbar_uploadImage_1_listener($event) { return ctx.onUploadImage($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3)(4, "div", 4, 5);
        ɵngcc0.ɵɵlistener("input", function NgxTextEditorComponent_Template_div_input_4_listener($event) { return ctx.onContentChange($event.target.innerHTML); })("focus", function NgxTextEditorComponent_Template_div_focus_4_listener() { return ctx.onTextAreaFocus(); })("blur", function NgxTextEditorComponent_Template_div_blur_4_listener() { return ctx.onTextAreaBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(8, "ngx-text-editor-message");
        ɵngcc0.ɵɵtemplate(9, NgxTextEditorComponent_ngx_grippie_9_Template, 1, 0, "ngx-grippie", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.config["width"])("min-width", ctx.config["minWidth"]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("config", ctx.config);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleProp("height", ctx.config["height"])("min-height", ctx.config["minHeight"])("resize", ctx.Utils == null ? null : ctx.Utils.canResize(ctx.resizer));
        ɵngcc0.ɵɵattribute("contenteditable", ctx.config["editable"])("translate", ctx.config["translate"])("spellcheck", ctx.config["spellcheck"]);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.placeholder || ctx.config["placeholder"], " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.resizer === "stack");
    } }, dependencies: function () { return [ɵngcc2.NgIf, NgxGrippieComponent, NgxTextEditorMessageComponent, NgxTextEditorToolbarComponent]; }, styles: [".ngx-text-editor[_ngcontent-%COMP%]{position:relative}.ngx-text-editor[_ngcontent-%COMP%]     [contenteditable=true]:empty:before{content:attr(placeholder);display:block;color:#868e96;opacity:1}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]{position:relative}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]   .ngx-text-editor-textarea[_ngcontent-%COMP%]{min-height:5rem;padding:.5rem .8rem 1rem;border:1px solid #ddd;background-color:transparent;overflow-x:hidden;overflow-y:auto;z-index:2;position:relative}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]   .ngx-text-editor-textarea.focus[_ngcontent-%COMP%], .ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]   .ngx-text-editor-textarea[_ngcontent-%COMP%]:focus{outline:0}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]   .ngx-text-editor-textarea[_ngcontent-%COMP%]     blockquote{margin-left:1rem;border-left:.2em solid #dfe2e5;padding-left:.5rem}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]   .ngx-text-editor-textarea[_ngcontent-%COMP%]::before{content:normal!important}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]     p{margin-bottom:0}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper[_ngcontent-%COMP%]   .ngx-text-editor-placeholder[_ngcontent-%COMP%]{display:none;position:absolute;top:0;padding:.5rem .8rem 1rem .9rem;z-index:1;color:#6c757d;opacity:1}.ngx-text-editor[_ngcontent-%COMP%]   .ngx-wrapper.show-placeholder[_ngcontent-%COMP%]   .ngx-text-editor-placeholder[_ngcontent-%COMP%]{display:block}"] });
NgxTextEditorComponent.ctorParameters = () => [
    { type: MessageService },
    { type: CommandExecutorService },
    { type: Renderer2 }
];
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "editable", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "spellcheck", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "translate", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "height", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "minHeight", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "width", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "minWidth", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "toolbar", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "resizer", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "config", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "showToolbar", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "enableToolbar", void 0);
__decorate([
    Input()
], NgxTextEditorComponent.prototype, "imageEndPoint", void 0);
__decorate([
    Output()
], NgxTextEditorComponent.prototype, "blur", void 0);
__decorate([
    Output()
], NgxTextEditorComponent.prototype, "focus", void 0);
__decorate([
    Output()
], NgxTextEditorComponent.prototype, "uploadImage", void 0);
__decorate([
    ViewChild('ngxTextArea', { static: true })
], NgxTextEditorComponent.prototype, "textArea", void 0);
__decorate([
    ViewChild('ngxWrapper', { static: true })
], NgxTextEditorComponent.prototype, "ngxWrapper", void 0);

let NgxGrippieComponent = class NgxGrippieComponent {
    /**
     * Constructor
     *
     * @param _editorComponent Editor component
     */
    constructor(_editorComponent) {
        this._editorComponent = _editorComponent;
        /** previous value befor resizing the editor */
        this.oldY = 0;
        /** set to true on mousedown event */
        this.grabber = false;
    }
    /**
     *
     * @param event Mouseevent
     *
     * Update the height of the editor when the grabber is dragged
     */
    onMouseMove(event) {
        if (!this.grabber) {
            return;
        }
        this._editorComponent.resizeTextArea(event.clientY - this.oldY);
        this.oldY = event.clientY;
    }
    /**
     *
     * @param event Mouseevent
     *
     * set the grabber to false on mouse up action
     */
    onMouseUp(event) {
        this.grabber = false;
    }
    onResize(event, resizer) {
        this.grabber = true;
        this.oldY = event.clientY;
        event.preventDefault();
    }
};
NgxGrippieComponent.ɵfac = function NgxGrippieComponent_Factory(t) { return new (t || NgxGrippieComponent)(ɵngcc0.ɵɵdirectiveInject(NgxTextEditorComponent)); };
NgxGrippieComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxGrippieComponent, selectors: [["ngx-grippie"]], hostBindings: function NgxGrippieComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousemove", function NgxGrippieComponent_mousemove_HostBindingHandler($event) { return ctx.onMouseMove($event); }, false, ɵngcc0.ɵɵresolveDocument)("mouseup", function NgxGrippieComponent_mouseup_HostBindingHandler($event) { return ctx.onMouseUp($event); }, false, ɵngcc0.ɵɵresolveDocument)("mousedown", function NgxGrippieComponent_mousedown_HostBindingHandler($event) { return ctx.onResize($event); });
    } }, decls: 4, vars: 0, consts: [[1, "ngx-text-editor-grippie"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "viewBox", "651.6 235 26 5", "width", "26", "height", "5", 2, "isolation", "isolate"], ["id", "sprites"], ["d", " M 651.6 235 L 653.6 235 L 653.6 237 L 651.6 237 M 654.6 238 L 656.6 238 L 656.6 240 L 654.6 240 M 660.6 238 L 662.6 238 L 662.6 240 L 660.6 240 M 666.6 238 L 668.6 238 L 668.6 240 L 666.6 240 M 672.6 238 L 674.6 238 L 674.6 240 L 672.6 240 M 657.6 235 L 659.6 235 L 659.6 237 L 657.6 237 M 663.6 235 L 665.6 235 L 665.6 237 L 663.6 237 M 669.6 235 L 671.6 235 L 671.6 237 L 669.6 237 M 675.6 235 L 677.6 235 L 677.6 237 L 675.6 237", "fill", "rgb(147,153,159)"]], template: function NgxGrippieComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1)(2, "g", 2);
        ɵngcc0.ɵɵelement(3, "path", 3);
        ɵngcc0.ɵɵelementEnd()()();
    } }, styles: [".ngx-text-editor-grippie[_ngcontent-%COMP%]{height:9px;background-color:#f1f1f1;position:relative;text-align:center;cursor:s-resize;border:1px solid #ddd;border-top:transparent}.ngx-text-editor-grippie[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;top:1.5px;width:50%;right:25%}"] });
NgxGrippieComponent.ctorParameters = () => [
    { type: NgxTextEditorComponent }
];
__decorate([
    HostListener('document:mousemove', ['$event'])
], NgxGrippieComponent.prototype, "onMouseMove", null);
__decorate([
    HostListener('document:mouseup', ['$event'])
], NgxGrippieComponent.prototype, "onMouseUp", null);
__decorate([
    HostListener('mousedown', ['$event'])
], NgxGrippieComponent.prototype, "onResize", null);

let NgxTextEditorMessageComponent = class NgxTextEditorMessageComponent {
    /**
     * @param _messageService service to send message to the editor
     */
    constructor(_messageService) {
        this._messageService = _messageService;
        /** property that holds the message to be displayed on the editor */
        this.ngxMessage = undefined;
        this._messageService.getMessage().subscribe((message) => this.ngxMessage = message);
    }
    /**
     * clears editor message
     */
    clearMessage() {
        this.ngxMessage = undefined;
    }
};
NgxTextEditorMessageComponent.ɵfac = function NgxTextEditorMessageComponent_Factory(t) { return new (t || NgxTextEditorMessageComponent)(ɵngcc0.ɵɵdirectiveInject(MessageService)); };
NgxTextEditorMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxTextEditorMessageComponent, selectors: [["ngx-text-editor-message"]], decls: 1, vars: 1, consts: [["class", "ngx-text-editor-message", 3, "dblclick", 4, "ngIf"], [1, "ngx-text-editor-message", 3, "dblclick"]], template: function NgxTextEditorMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxTextEditorMessageComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.ngxMessage);
    } }, dependencies: [ɵngcc2.NgIf], styles: [".ngx-text-editor-message[_ngcontent-%COMP%]{font-size:80%;background-color:#f1f1f1;border:1px solid #ddd;border-top:transparent;padding:0 .5rem .1rem;transition:.5s ease-in}"] });
NgxTextEditorMessageComponent.ctorParameters = () => [
    { type: MessageService }
];

let NgxTextEditorToolbarComponent = class NgxTextEditorToolbarComponent {
    constructor(_popOverConfig, _formBuilder, _messageService, _commandExecutorService) {
        this._popOverConfig = _popOverConfig;
        this._formBuilder = _formBuilder;
        this._messageService = _messageService;
        this._commandExecutorService = _commandExecutorService;
        /** set to false when image is being uploaded */
        this.uploadComplete = true;
        /** upload percentage */
        this.updloadPercentage = 0;
        /** set to true when the image is being uploaded */
        this.isUploading = false;
        /** which tab to active for color insertion */
        this.selectedColorTab = 'textColor';
        /** font family name */
        this.fontName = '';
        /** font size */
        this.fontSize = '';
        /** hex color code */
        this.hexColor = '';
        /** show/hide image uploader */
        this.isImageUploader = false;
        this.wasH1Pressed = false;
        /** Icons for the Toolbar */
        this.icons = {
            heading: faHeading,
            bold: faBold,
            italic: faItalic,
            underline: faUnderline,
            strikethrough: faStrikethrough,
            superscript: faSuperscript,
            subscript: faSubscript,
            font: faFont,
            textheight: faTextHeight,
            tint: faTint,
            alignleft: faAlignLeft,
            aligncenter: faAlignCenter,
            alignright: faAlignRight,
            alignjustify: faAlignJustify,
            indent: faIndent,
            outdent: faOutdent,
            scissors: faCut,
            fileso: faCopy,
            trash: faTrashAlt,
            eraser: faEraser,
            undo: faUndo,
            repeat: faRedo,
            paragraph: faParagraph,
            quoteleft: faQuoteLeft,
            quoteright: faQuoteRight,
            minus: faMinus,
            listul: faListUl,
            listol: faListOl,
            link: faLink,
            chainbroken: faUnlink,
            pictureo: faImage,
            youtubeplay: faYoutube,
            upload: faFileUpload
        };
        /**
         * Emits an event when a toolbar button is clicked
         */
        this.execute = new EventEmitter();
        /**
         * Emits an event then an image is selected
         */
        this.uploadImage = new EventEmitter();
        this._popOverConfig.outsideClick = true;
        this._popOverConfig.placement = 'bottom';
        this._popOverConfig.container = 'body';
    }
    /**
     * enable or diable toolbar based on configuration
     *
     * @param value name of the toolbar buttons
     */
    canEnableToolbarOptions(value) {
        return canEnableToolbarOptions(value, this.config['toolbar']);
    }
    /**
     * triggers command from the toolbar to be executed and emits an event
     *
     * @param command name of the command to be executed
     */
    triggerCommand(command) {
        this.execute.emit(command);
    }
    /**
     * create URL insert form
     */
    buildUrlForm() {
        this.urlForm = this._formBuilder.group({
            urlLink: ['', [Validators.required]],
            urlText: ['', [Validators.required]],
            urlNewTab: [true]
        });
    }
    /**
     * inserts link in the editor
     */
    insertLink() {
        try {
            this._commandExecutorService.createLink(this.urlForm.value);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
        /** reset form to default */
        this.buildUrlForm();
        /** close inset URL pop up */
        this.urlPopover.hide();
    }
    /**
     * create insert image form
     */
    buildImageForm() {
        this.imageForm = this._formBuilder.group({
            imageUrl: ['', [Validators.required]]
        });
    }
    /**
     * create insert image form
     */
    buildVideoForm() {
        this.videoForm = this._formBuilder.group({
            videoUrl: ['', [Validators.required]],
            height: [''],
            width: ['']
        });
    }
    /**
     * Executed when file is selected
     *
     * @param e onChange event
     */
    onFileChange(e) {
        this.uploadComplete = false;
        this.isUploading = true;
        if (e.target.files.length > 0) {
            const file = e.target.files[0];
            if (!this.config.imageEndPoint) {
                this.uploadImage.emit(file);
                this.uploadComplete = true;
                this.isUploading = false;
            }
            else {
                try {
                    this._commandExecutorService.uploadImage(file, this.config.imageEndPoint).subscribe(event => {
                        if (event.type) {
                            this.updloadPercentage = Math.round(100 * event.loaded / event.total);
                        }
                        if (event instanceof HttpResponse) {
                            try {
                                this._commandExecutorService.insertImage(event.body.url);
                            }
                            catch (error) {
                                this._messageService.sendMessage(error.message);
                            }
                            this.uploadComplete = true;
                            this.isUploading = false;
                        }
                    });
                }
                catch (error) {
                    this._messageService.sendMessage(error.message);
                    this.uploadComplete = true;
                    this.isUploading = false;
                }
            }
        }
    }
    /** insert image in the editor */
    insertImage() {
        try {
            this._commandExecutorService.insertImage(this.imageForm.value.imageUrl);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
        /** reset form to default */
        this.buildImageForm();
        /** close inset URL pop up */
        this.imagePopover.hide();
    }
    /** insert image in the editor */
    insertVideo() {
        try {
            this._commandExecutorService.insertVideo(this.videoForm.value);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
        /** reset form to default */
        this.buildVideoForm();
        /** close inset URL pop up */
        this.videoPopover.hide();
    }
    /** inser text/background color */
    insertColor(color, where) {
        try {
            this._commandExecutorService.insertColor(color, where);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
        this.colorPopover.hide();
    }
    /** set font size */
    setFontSize(fontSize) {
        try {
            this._commandExecutorService.setFontSize(fontSize);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
        this.fontSizePopover.hide();
    }
    /** set font Name/family */
    setFontName(fontName) {
        try {
            this._commandExecutorService.setFontName(fontName);
        }
        catch (error) {
            this._messageService.sendMessage(error.message);
        }
        this.fontSizePopover.hide();
    }
    ngOnInit() {
        this.buildUrlForm();
        this.buildImageForm();
        this.buildVideoForm();
    }
    toggleHeading(heading) {
        if (!this.wasH1Pressed) {
            this.execute.emit(heading);
        }
        else {
            this.execute.emit('clear');
        }
        this.wasH1Pressed = !this.wasH1Pressed;
    }
};
NgxTextEditorToolbarComponent.ɵfac = function NgxTextEditorToolbarComponent_Factory(t) { return new (t || NgxTextEditorToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.PopoverConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵdirectiveInject(MessageService), ɵngcc0.ɵɵdirectiveInject(CommandExecutorService)); };
NgxTextEditorToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxTextEditorToolbarComponent, selectors: [["ngx-text-editor-toolbar"]], viewQuery: function NgxTextEditorToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
        ɵngcc0.ɵɵviewQuery(_c3, 7);
        ɵngcc0.ɵɵviewQuery(_c4, 7);
        ɵngcc0.ɵɵviewQuery(_c5, 7);
        ɵngcc0.ɵɵviewQuery(_c6, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.urlPopover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.imagePopover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.videoPopover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fontSizePopover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.colorPopover = _t.first);
    } }, inputs: { config: "config" }, outputs: { execute: "execute", uploadImage: "uploadImage" }, features: [ɵngcc0.ɵɵProvidersFeature([PopoverConfig])], decls: 13, vars: 1, consts: [["class", "ngx-toolbar", 4, "ngIf"], ["insertLinkTemplate", ""], ["insertImageTemplate", ""], ["insertVideoTemplate", ""], ["insertColorTemplate", ""], ["fontSizeTemplate", ""], ["fontNameTemplate", ""], [1, "ngx-toolbar"], [1, "ngx-toolbar-set"], ["type", "button", "class", "ngx-text-editor-button", "title", "H1", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "ngx-text-editor-button", "title", "H2", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "ngx-text-editor-button", "title", "H3", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "ngx-text-editor-button", 3, "title", "disabled", "click", 4, "ngIf"], ["type", "button", "class", "ngx-text-editor-button", "containerClass", "ngxePopover", 3, "title", "popover", "disabled", "click", 4, "ngIf"], ["type", "button", "class", "ngx-text-editor-button", "containerClass", "ngxePopover", 3, "popover", "title", "disabled", "click", 4, "ngIf"], ["type", "button", "title", "H1", 1, "ngx-text-editor-button", 3, "disabled", "click"], [3, "icon"], [1, "headerNumber"], ["type", "button", "title", "H2", 1, "ngx-text-editor-button", 3, "disabled", "click"], ["type", "button", "title", "H3", 1, "ngx-text-editor-button", 3, "disabled", "click"], ["type", "button", 1, "ngx-text-editor-button", 3, "title", "disabled", "click"], ["type", "button", "containerClass", "ngxePopover", 1, "ngx-text-editor-button", 3, "title", "popover", "disabled", "click"], ["fontNamePopover", "bs-popover"], ["fontSizePopover", "bs-popover"], ["colorPopover", "bs-popover"], ["type", "button", "containerClass", "ngxePopover", 1, "ngx-text-editor-button", 3, "popover", "title", "disabled", "click"], ["urlPopover", "bs-popover"], ["imagePopover", "bs-popover"], ["videoPopover", "bs-popover"], [1, "ngxe-popover", "extra-gt"], ["autocomplete", "off", 3, "formGroup", "ngSubmit"], [1, "form-group"], ["for", "urlInput", 1, "small"], ["type", "text", "id", "URLInput", "formControlName", "urlLink", "required", "", 1, "form-control-sm", 3, "placeholder"], ["for", "urlTextInput", 1, "small"], ["type", "text", "id", "urlTextInput", "formControlName", "urlText", "required", "", 1, "form-control-sm", 3, "placeholder"], [1, "form-check"], ["type", "checkbox", "id", "urlNewTab", "formControlName", "urlNewTab", 1, "form-check-input"], ["for", "urlNewTab", 1, "form-check-label"], ["type", "submit", 1, "btn-primary", "btn-sm", "btn"], [1, "ngxe-popover", "imgc-ctnr"], [1, "imgc-topbar", "btn-ctnr"], ["type", "button", 1, "btn", 3, "ngClass", "click"], [1, "imgc-ctnt", "is-image"], [4, "ngIf", "ngIfElse"], ["imageUploder", ""], ["insertImageLink", ""], ["class", "progress", 4, "ngIf"], [1, "ngx-insert-img-ph"], [4, "ngIf"], [1, "ngxe-img-upl-frm"], ["type", "file", "accept", "image/*", 3, "disabled", "change"], ["autocomplete", "off", 1, "extra-gt", 3, "formGroup", "ngSubmit"], ["for", "imageURLInput", 1, "small"], ["type", "text", "id", "imageURLInput", "formControlName", "imageUrl", "required", "", 1, "form-control-sm", 3, "placeholder"], [1, "progress"], [1, "progress-bar", "progress-bar-striped", "progress-bar-animated", "bg-success", 3, "ngClass"], ["type", "button", 1, "btn", "active"], ["for", "videoURLInput", 1, "small"], ["type", "text", "id", "videoURLInput", "formControlName", "videoUrl", "required", "", 1, "form-control-sm", 3, "placeholder"], [1, "row", "form-group"], [1, "col"], ["type", "text", "formControlName", "height", "pattern", "[0-9]", 1, "form-control-sm", 3, "placeholder"], ["type", "text", "formControlName", "width", "pattern", "[0-9]", 1, "form-control-sm", 3, "placeholder"], [1, "small"], [1, "imgc-topbar", "two-tabs"], [3, "ngClass", "click"], [1, "imgc-ctnt", "is-color", "extra-gt1"], ["autocomplete", "off"], ["for", "hexInput", 1, "small"], ["type", "text", "id", "hexInput", "name", "hexInput", "maxlength", "7", "required", "", 1, "form-control-sm", 3, "placeholder", "ngModel", "ngModelChange"], ["type", "button", 1, "btn-primary", "btn-sm", "btn", 3, "click"], [1, "ngxe-popover", "extra-gt1"], ["for", "fontSize", 1, "small"], ["type", "text", "id", "fontSize", "name", "fontSize", "required", "", 1, "form-control-sm", 3, "placeholder", "ngModel", "ngModelChange"], ["type", "text", "id", "fontSize", "name", "fontName", "required", "", 1, "form-control-sm", 3, "placeholder", "ngModel", "ngModelChange"]], template: function NgxTextEditorToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxTextEditorToolbarComponent_div_0_Template, 41, 34, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgxTextEditorToolbarComponent_ng_template_1_Template, 16, 7, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, NgxTextEditorToolbarComponent_ng_template_3_Template, 14, 13, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, NgxTextEditorToolbarComponent_ng_template_5_Template, 19, 8, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, NgxTextEditorToolbarComponent_ng_template_7_Template, 14, 12, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, NgxTextEditorToolbarComponent_ng_template_9_Template, 8, 4, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, NgxTextEditorToolbarComponent_ng_template_11_Template, 8, 4, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config["showToolbar"]);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.DefaultValueAccessor, ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgControlStatusGroup, ɵngcc4.RequiredValidator, ɵngcc4.MaxLengthValidator, ɵngcc4.PatternValidator, ɵngcc4.NgModel, ɵngcc4.NgForm, ɵngcc3.PopoverDirective, ɵngcc4.FormGroupDirective, ɵngcc4.FormControlName, ɵngcc5.FaIconComponent], styles: [".ngxePopover.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-style:normal;font-weight:400;line-height:1.5;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}  .ngxePopover.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}  .ngxePopover.popover .arrow::after,   .ngxePopover.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}  .ngxePopover.popover .popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}  .ngxePopover.popover .popover-header:empty{display:none}  .ngxePopover.popover .popover-body{padding:.5rem .75rem;color:#212529}  .ngxePopover.popover.bs-popover-auto[x-placement^=top],   .ngxePopover.popover.bs-popover-top{margin-bottom:.5rem}  .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow,   .ngxePopover.popover.bs-popover-top .arrow{bottom:calc((.5rem + 1px) * -1)}  .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::after,   .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::before,   .ngxePopover.popover.bs-popover-top .arrow::after,   .ngxePopover.popover.bs-popover-top .arrow::before{border-width:.5rem .5rem 0}  .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::before,   .ngxePopover.popover.bs-popover-top .arrow::before{bottom:0;border-top-color:rgba(0,0,0,.25)}  .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::after,   .ngxePopover.popover.bs-popover-top .arrow::after{bottom:1px;border-top-color:#fff}  .ngxePopover.popover.bs-popover-auto[x-placement^=right],   .ngxePopover.popover.bs-popover-right{margin-left:.5rem}  .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow,   .ngxePopover.popover.bs-popover-right .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}  .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::after,   .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::before,   .ngxePopover.popover.bs-popover-right .arrow::after,   .ngxePopover.popover.bs-popover-right .arrow::before{border-width:.5rem .5rem .5rem 0}  .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::before,   .ngxePopover.popover.bs-popover-right .arrow::before{left:0;border-right-color:rgba(0,0,0,.25)}  .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::after,   .ngxePopover.popover.bs-popover-right .arrow::after{left:1px;border-right-color:#fff}  .ngxePopover.popover.bs-popover-auto[x-placement^=bottom],   .ngxePopover.popover.bs-popover-bottom{margin-top:.5rem}  .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow,   .ngxePopover.popover.bs-popover-bottom .arrow{left:45%!important;top:calc((.5rem + 1px) * -1)}  .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::after,   .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::before,   .ngxePopover.popover.bs-popover-bottom .arrow::after,   .ngxePopover.popover.bs-popover-bottom .arrow::before{border-width:0 .5rem .5rem}  .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::before,   .ngxePopover.popover.bs-popover-bottom .arrow::before{top:0;border-bottom-color:rgba(0,0,0,.25)}  .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::after,   .ngxePopover.popover.bs-popover-bottom .arrow::after{top:1px;border-bottom-color:#fff}  .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .popover-header::before,   .ngxePopover.popover.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}  .ngxePopover.popover.bs-popover-auto[x-placement^=left],   .ngxePopover.popover.bs-popover-left{margin-right:.5rem}  .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow,   .ngxePopover.popover.bs-popover-left .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}  .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::after,   .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::before,   .ngxePopover.popover.bs-popover-left .arrow::after,   .ngxePopover.popover.bs-popover-left .arrow::before{border-width:.5rem 0 .5rem .5rem}  .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::before,   .ngxePopover.popover.bs-popover-left .arrow::before{right:0;border-left-color:rgba(0,0,0,.25)}  .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::after,   .ngxePopover.popover.bs-popover-left .arrow::after{right:1px;border-left-color:#fff}  .ngxePopover .btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}  .ngxePopover .btn.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}  .ngxePopover .btn:active,   .ngxePopover .btn:focus{outline:0;box-shadow:none}  .ngxePopover .btn.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}  .ngxePopover .btn.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}  .ngxePopover .btn:not(:disabled):not(.disabled){cursor:pointer}  .ngxePopover form .form-group{margin-bottom:1rem}  .ngxePopover form .form-group input{overflow:visible}  .ngxePopover form .form-group .form-control-sm{width:100%;outline:0;border:none;border-bottom:1px solid #bdbdbd;border-radius:0;margin-bottom:1px;padding:.25rem .5rem;font-size:.875rem;line-height:1.5}  .ngxePopover form .form-group.row{display:flex;flex-wrap:wrap;margin-left:0;margin-right:0}  .ngxePopover form .form-group.row .col{flex-basis:0;flex-grow:1;max-width:100%;padding:0}  .ngxePopover form .form-group.row .col:first-child{padding-right:15px}  .ngxePopover form .form-check{position:relative;display:block;padding-left:1.25rem}  .ngxePopover form .form-check .form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.ngx-toolbar[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;background-color:#f5f5f5;font-size:.8rem;padding:.2rem .2rem 0;border:1px solid #ddd}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]{display:flex;border-radius:5px;background-color:#fff;margin-right:.2rem;margin-bottom:.2rem}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]{background-color:transparent;padding:.4rem;min-width:2.5rem;border:1px solid #ddd;border-right:transparent}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]   .headerNumber[_ngcontent-%COMP%]{font-size:15px;top:1px;position:relative;left:1px;font-weight:700}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]:hover{cursor:pointer;background-color:#f1f1f1;transition:.2s}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button.focus[_ngcontent-%COMP%], .ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]:focus{outline:0}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]:last-child{border-right:1px solid #ddd;border-top-right-radius:5px;border-bottom-right-radius:5px}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.ngx-toolbar[_ngcontent-%COMP%]   .ngx-toolbar-set[_ngcontent-%COMP%]   .ngx-text-editor-button[_ngcontent-%COMP%]:disabled{background-color:#f5f5f5;pointer-events:none;cursor:not-allowed}  .popover{border-top-right-radius:0;border-top-left-radius:0}  .ngxe-popover{min-width:15rem;white-space:nowrap}  .ngxe-popover .extra-gt,   .ngxe-popover.extra-gt{padding-top:.5rem!important}  .ngxe-popover .extra-gt1,   .ngxe-popover.extra-gt1{padding-top:.75rem!important}  .ngxe-popover .extra-gt2,   .ngxe-popover.extra-gt2{padding-top:1rem!important}  .ngxe-popover .form-group label{display:none;margin:0}  .ngxe-popover .form-group .form-control-sm{width:100%;outline:0;border:none;border-bottom:1px solid #bdbdbd;border-radius:0;margin-bottom:1px;padding-left:0;padding-right:0}  .ngxe-popover .form-group .form-control-sm:active,   .ngxe-popover .form-group .form-control-sm:focus{border-bottom:2px solid #1e88e5;box-shadow:none;margin-bottom:0}  .ngxe-popover .form-group .form-control-sm.ng-dirty.ng-invalid:not(.ng-pristine){border-bottom:2px solid red}  .ngxe-popover .form-check{margin-bottom:1rem}  .ngxe-popover .btn:focus{box-shadow:none!important}  .ngxe-popover.imgc-ctnr{margin:-.5rem -.75rem}  .ngxe-popover.imgc-ctnr .imgc-topbar{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);border-bottom:0}  .ngxe-popover.imgc-ctnr .imgc-topbar.btn-ctnr button{background-color:transparent;border-radius:0}  .ngxe-popover.imgc-ctnr .imgc-topbar.btn-ctnr button:hover{cursor:pointer;background-color:#f1f1f1;transition:.2s}  .ngxe-popover.imgc-ctnr .imgc-topbar.btn-ctnr button.active{color:#007bff;transition:.2s}  .ngxe-popover.imgc-ctnr .imgc-topbar.two-tabs span{width:50%;display:inline-flex;justify-content:center;padding:.4rem 0;margin:0 -1px 2px}  .ngxe-popover.imgc-ctnr .imgc-topbar.two-tabs span:hover{cursor:pointer}  .ngxe-popover.imgc-ctnr .imgc-topbar.two-tabs span.active{margin-bottom:-2px;border-bottom:2px solid #007bff;color:#007bff}  .ngxe-popover.imgc-ctnr .imgc-ctnt{padding:.5rem}  .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .progress{height:.5rem;margin:.5rem -.5rem -.6rem}  .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image p{margin:0}  .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph{border:2px dashed #bdbdbd;padding:1.8rem 0;position:relative;letter-spacing:1px;text-align:center}  .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph:hover{background:#ebebeb}  .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph .ngxe-img-upl-frm{opacity:0;position:absolute;top:0;bottom:0;left:0;right:0;z-index:2147483640;overflow:hidden;margin:0;padding:0;width:100%}  .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph .ngxe-img-upl-frm input{cursor:pointer;position:absolute;right:0;top:0;bottom:0;margin:0}"] });
NgxTextEditorToolbarComponent.ctorParameters = () => [
    { type: PopoverConfig },
    { type: FormBuilder },
    { type: MessageService },
    { type: CommandExecutorService }
];
__decorate([
    Input()
], NgxTextEditorToolbarComponent.prototype, "config", void 0);
__decorate([
    ViewChild('urlPopover', { static: true })
], NgxTextEditorToolbarComponent.prototype, "urlPopover", void 0);
__decorate([
    ViewChild('imagePopover', { static: true })
], NgxTextEditorToolbarComponent.prototype, "imagePopover", void 0);
__decorate([
    ViewChild('videoPopover', { static: true })
], NgxTextEditorToolbarComponent.prototype, "videoPopover", void 0);
__decorate([
    ViewChild('fontSizePopover', { static: true })
], NgxTextEditorToolbarComponent.prototype, "fontSizePopover", void 0);
__decorate([
    ViewChild('colorPopover', { static: true })
], NgxTextEditorToolbarComponent.prototype, "colorPopover", void 0);
__decorate([
    Output()
], NgxTextEditorToolbarComponent.prototype, "execute", void 0);
__decorate([
    Output()
], NgxTextEditorToolbarComponent.prototype, "uploadImage", void 0);

let NgxTextEditorModule = class NgxTextEditorModule {
};
NgxTextEditorModule.ɵfac = function NgxTextEditorModule_Factory(t) { return new (t || NgxTextEditorModule)(); };
NgxTextEditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxTextEditorModule });
NgxTextEditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        CommandExecutorService,
        MessageService
    ], imports: [CommonModule,
        FormsModule,
        PopoverModule.forRoot(),
        ReactiveFormsModule,
        FontAwesomeModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommandExecutorService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageService, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTextEditorComponent, [{
        type: Component,
        args: [{ selector: 'ngx-text-editor', template: "<div class=\"ngx-text-editor\"\r\n     id=\"ngxTextEditor\"\r\n     [style.width]=\"config['width']\"\r\n     [style.minWidth]=\"config['minWidth']\"\r\n     tabindex=\"0\"\r\n     (focus)=\"onEditorFocus()\">\r\n\r\n  <ngx-text-editor-toolbar [config]=\"config\"\r\n                           (execute)=\"executeCommand($event)\"\r\n                           (uploadImage)=\"onUploadImage($event)\"></ngx-text-editor-toolbar>\r\n\r\n  <!-- text area -->\r\n  <div #ngxWrapper\r\n       class=\"ngx-wrapper\">\r\n    <div #ngxTextArea\r\n         class=\"ngx-text-editor-textarea\"\r\n         [attr.contenteditable]=\"config['editable']\"\r\n         (input)=\"onContentChange($event.target.innerHTML)\"\r\n         [attr.translate]=\"config['translate']\"\r\n         [attr.spellcheck]=\"config['spellcheck']\"\r\n         [style.height]=\"config['height']\"\r\n         [style.minHeight]=\"config['minHeight']\"\r\n         [style.resize]=\"Utils?.canResize(resizer)\"\r\n         (focus)=\"onTextAreaFocus()\"\r\n         (blur)=\"onTextAreaBlur()\"></div>\r\n\r\n    <span class=\"ngx-text-editor-placeholder\">\r\n      {{ placeholder || config['placeholder'] }}\r\n    </span>\r\n  </div>\r\n\r\n  <ngx-text-editor-message></ngx-text-editor-message>\r\n\r\n  <ngx-grippie *ngIf=\"resizer === 'stack'\"></ngx-grippie>\r\n</div>\r\n", providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NgxTextEditorComponent_1),
                        multi: true
                    }], styles: [".ngx-text-editor{position:relative}.ngx-text-editor ::ng-deep [contenteditable=true]:empty:before{content:attr(placeholder);display:block;color:#868e96;opacity:1}.ngx-text-editor .ngx-wrapper{position:relative}.ngx-text-editor .ngx-wrapper .ngx-text-editor-textarea{min-height:5rem;padding:.5rem .8rem 1rem;border:1px solid #ddd;background-color:transparent;overflow-x:hidden;overflow-y:auto;z-index:2;position:relative}.ngx-text-editor .ngx-wrapper .ngx-text-editor-textarea.focus,.ngx-text-editor .ngx-wrapper .ngx-text-editor-textarea:focus{outline:0}.ngx-text-editor .ngx-wrapper .ngx-text-editor-textarea ::ng-deep blockquote{margin-left:1rem;border-left:.2em solid #dfe2e5;padding-left:.5rem}.ngx-text-editor .ngx-wrapper .ngx-text-editor-textarea::before{content:normal!important}.ngx-text-editor .ngx-wrapper ::ng-deep p{margin-bottom:0}.ngx-text-editor .ngx-wrapper .ngx-text-editor-placeholder{display:none;position:absolute;top:0;padding:.5rem .8rem 1rem .9rem;z-index:1;color:#6c757d;opacity:1}.ngx-text-editor .ngx-wrapper.show-placeholder .ngx-text-editor-placeholder{display:block}"] }]
    }], function () { return [{ type: MessageService }, { type: CommandExecutorService }, { type: ɵngcc0.Renderer2 }]; }, { resizer: [{
            type: Input
        }], config: [{
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], uploadImage: [{
            type: Output
        }], height: [{
            type: Input
        }], editable: [{
            type: Input
        }], spellcheck: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], translate: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], width: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], toolbar: [{
            type: Input
        }], showToolbar: [{
            type: Input
        }], enableToolbar: [{
            type: Input
        }], imageEndPoint: [{
            type: Input
        }], textArea: [{
            type: ViewChild,
            args: ['ngxTextArea', { static: true }]
        }], ngxWrapper: [{
            type: ViewChild,
            args: ['ngxWrapper', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxGrippieComponent, [{
        type: Component,
        args: [{ selector: 'ngx-grippie', template: "<div class=\"ngx-text-editor-grippie\">\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"isolation:isolate\" viewBox=\"651.6 235 26 5\"\r\n    width=\"26\" height=\"5\">\r\n    <g id=\"sprites\">\r\n      <path d=\" M 651.6 235 L 653.6 235 L 653.6 237 L 651.6 237 M 654.6 238 L 656.6 238 L 656.6 240 L 654.6 240 M 660.6 238 L 662.6 238 L 662.6 240 L 660.6 240 M 666.6 238 L 668.6 238 L 668.6 240 L 666.6 240 M 672.6 238 L 674.6 238 L 674.6 240 L 672.6 240 M 657.6 235 L 659.6 235 L 659.6 237 L 657.6 237 M 663.6 235 L 665.6 235 L 665.6 237 L 663.6 237 M 669.6 235 L 671.6 235 L 671.6 237 L 669.6 237 M 675.6 235 L 677.6 235 L 677.6 237 L 675.6 237\"\r\n        fill=\"rgb(147,153,159)\" />\r\n    </g>\r\n  </svg>\r\n</div>\r\n", styles: [".ngx-text-editor-grippie{height:9px;background-color:#f1f1f1;position:relative;text-align:center;cursor:s-resize;border:1px solid #ddd;border-top:transparent}.ngx-text-editor-grippie svg{position:absolute;top:1.5px;width:50%;right:25%}"] }]
    }], function () { return [{ type: NgxTextEditorComponent }]; }, { 
    /**
     *
     * @param event Mouseevent
     *
     * Update the height of the editor when the grabber is dragged
     */
    onMouseMove: [{
            type: HostListener,
            args: ['document:mousemove', ['$event']]
        }], 
    /**
     *
     * @param event Mouseevent
     *
     * set the grabber to false on mouse up action
     */
    onMouseUp: [{
            type: HostListener,
            args: ['document:mouseup', ['$event']]
        }], onResize: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTextEditorMessageComponent, [{
        type: Component,
        args: [{ selector: 'ngx-text-editor-message', template: "<div class=\"ngx-text-editor-message\" *ngIf=\"ngxMessage\" (dblclick)=\"clearMessage()\">\r\n  {{ ngxMessage }}\r\n</div>\r\n", styles: [".ngx-text-editor-message{font-size:80%;background-color:#f1f1f1;border:1px solid #ddd;border-top:transparent;padding:0 .5rem .1rem;transition:.5s ease-in}"] }]
    }], function () { return [{ type: MessageService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTextEditorToolbarComponent, [{
        type: Component,
        args: [{ selector: 'ngx-text-editor-toolbar', template: "<div class=\"ngx-toolbar\" *ngIf=\"config['showToolbar']\">\r\n  <div class=\"ngx-toolbar-set\">\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('h1')\" (click)=\"toggleHeading('h1')\"\r\n            title=\"H1\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.heading\"></fa-icon><span class=\"headerNumber\">1</span>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('h2')\" (click)=\"toggleHeading('h2')\"\r\n            title=\"H2\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.heading\"></fa-icon><span class=\"headerNumber\">2</span>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('h3')\" (click)=\"toggleHeading('h3')\"\r\n            title=\"H3\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.heading\"></fa-icon><span class=\"headerNumber\">3</span>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('bold')\" (click)=\"triggerCommand('bold')\"\r\n            title=\"{{config.toolbarTitle['bold']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.bold\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('italic')\" (click)=\"triggerCommand('italic')\"\r\n            title=\"{{config.toolbarTitle['italic']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.italic\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('underline')\" (click)=\"triggerCommand('underline')\"\r\n            title=\"{{config.toolbarTitle['underline']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.underline\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('strikeThrough')\" (click)=\"triggerCommand('strikeThrough')\"\r\n            title=\"{{config.toolbarTitle['strikeThrough']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.strikethrough\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('superscript')\" (click)=\"triggerCommand('superscript')\"\r\n            title=\"{{config.toolbarTitle['superscript']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.superscript\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('subscript')\" (click)=\"triggerCommand('subscript')\"\r\n            title=\"{{config.toolbarTitle['subscript']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.subscript\"></fa-icon>\r\n    </button>\r\n  </div>\r\n  <div class=\"ngx-toolbar-set\">\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('fontName')\" (click)=\"fontName = ''\"\r\n            title=\"{{config.toolbarTitle['fontName']}}\" [popover]=\"fontNameTemplate\" #fontNamePopover=\"bs-popover\" containerClass=\"ngxePopover\"\r\n            [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.font\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('fontSize')\" (click)=\"fontSize = ''\"\r\n            title=\"{{config.toolbarTitle['fontSize']}}\" [popover]=\"fontSizeTemplate\" #fontSizePopover=\"bs-popover\" containerClass=\"ngxePopover\"\r\n            [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.textheight\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('color')\" (click)=\"hexColor = ''\"\r\n            title=\"{{config.toolbarTitle['color']}}\" [popover]=\"insertColorTemplate\" #colorPopover=\"bs-popover\" containerClass=\"ngxePopover\"\r\n            [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.tint\"></fa-icon>\r\n    </button>\r\n  </div>\r\n  <div class=\"ngx-toolbar-set\">\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('justifyLeft')\" (click)=\"triggerCommand('justifyLeft')\"\r\n            title=\"{{config.toolbarTitle['justifyLeft']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.alignleft\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('justifyCenter')\" (click)=\"triggerCommand('justifyCenter')\"\r\n            title=\"{{config.toolbarTitle['justifyCenter']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.aligncenter\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('justifyRight')\" (click)=\"triggerCommand('justifyRight')\"\r\n            title=\"{{config.toolbarTitle['justifyRight']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.alignright\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('justifyFull')\" (click)=\"triggerCommand('justifyFull')\"\r\n            title=\"{{config.toolbarTitle['justifyFull']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.alignjustify\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('indent')\" (click)=\"triggerCommand('indent')\"\r\n            title=\"{{config.toolbarTitle['indent']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.indent\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('outdent')\" (click)=\"triggerCommand('outdent')\"\r\n            title=\"{{config.toolbarTitle['outdent']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.outdent\"></fa-icon>\r\n    </button>\r\n  </div>\r\n  <div class=\"ngx-toolbar-set\">\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('cut')\" (click)=\"triggerCommand('cut')\"\r\n            title=\"{{config.toolbarTitle['cut']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.scissors\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('copy')\" (click)=\"triggerCommand('copy')\"\r\n            title=\"{{config.toolbarTitle['copy']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.fileso\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('delete')\" (click)=\"triggerCommand('delete')\"\r\n            title=\"{{config.toolbarTitle['delete']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.trash\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('removeFormat')\" (click)=\"triggerCommand('removeFormat')\"\r\n            title=\"{{config.toolbarTitle['removeFormat']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.eraser\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('undo')\" (click)=\"triggerCommand('undo')\"\r\n            title=\"{{config.toolbarTitle['undo']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.undo\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('redo')\" (click)=\"triggerCommand('redo')\"\r\n            title=\"{{config.toolbarTitle['redo']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.repeat\"></fa-icon>\r\n    </button>\r\n  </div>\r\n  <div class=\"ngx-toolbar-set\">\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('paragraph')\" (click)=\"triggerCommand('insertParagraph')\"\r\n            title=\"{{config.toolbarTitle['paragraph']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.paragraph\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('blockquote')\" (click)=\"triggerCommand('blockquote')\"\r\n            title=\"{{config.toolbarTitle['blockquote']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.quoteleft\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('removeBlockquote')\" (click)=\"triggerCommand('removeBlockquote')\"\r\n            title=\"{{config.toolbarTitle['removeBlockquote']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.quoteright\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('horizontalLine')\" (click)=\"triggerCommand('insertHorizontalRule')\"\r\n            title=\"{{config.toolbarTitle['horizontalLine']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.minus\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('unorderedList')\" (click)=\"triggerCommand('insertUnorderedList')\"\r\n            title=\"{{config.toolbarTitle['unorderedList']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.listul\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('orderedList')\" (click)=\"triggerCommand('insertOrderedList')\"\r\n            title=\"{{config.toolbarTitle['orderedList']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.listol\"></fa-icon>\r\n    </button>\r\n  </div>\r\n  <div class=\"ngx-toolbar-set\">\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('link')\" (click)=\"buildUrlForm()\"\r\n            [popover]=\"insertLinkTemplate\" title=\"{{config.toolbarTitle['link']}}\" #urlPopover=\"bs-popover\" containerClass=\"ngxePopover\"\r\n            [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.link\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('unlink')\" (click)=\"triggerCommand('unlink')\"\r\n            title=\"{{config.toolbarTitle['unlink']}}\" [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.chainbroken\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('image')\" (click)=\"buildImageForm()\"\r\n            title=\"{{config.toolbarTitle['image']}}\" [popover]=\"insertImageTemplate\" #imagePopover=\"bs-popover\" containerClass=\"ngxePopover\"\r\n            [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.pictureo\"></fa-icon>\r\n    </button>\r\n    <button type=\"button\" class=\"ngx-text-editor-button\" *ngIf=\"canEnableToolbarOptions('video')\" (click)=\"buildVideoForm()\"\r\n            title=\"{{config.toolbarTitle['video']}}\" [popover]=\"insertVideoTemplate\" #videoPopover=\"bs-popover\" containerClass=\"ngxePopover\"\r\n            [disabled]=\"!config['enableToolbar']\">\r\n      <fa-icon [icon]=\"icons.youtubeplay\"></fa-icon>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<!-- URL Popover template -->\r\n<ng-template #insertLinkTemplate>\r\n  <div class=\"ngxe-popover extra-gt\">\r\n    <form [formGroup]=\"urlForm\" (ngSubmit)=\"urlForm.valid && insertLink()\" autocomplete=\"off\">\r\n      <div class=\"form-group\">\r\n        <label for=\"urlInput\" class=\"small\">{{config.toolbarTitle['URLInput']}}</label>\r\n        <input type=\"text\" class=\"form-control-sm\" id=\"URLInput\" placeholder=\"{{config.toolbarTitle['URLInput']}}\" formControlName=\"urlLink\" required>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"urlTextInput\" class=\"small\">{{config.toolbarTitle['urlTextInput']}}</label>\r\n        <input type=\"text\" class=\"form-control-sm\" id=\"urlTextInput\" placeholder=\"{{config.toolbarTitle['urlTextInput']}}\" formControlName=\"urlText\"\r\n          required>\r\n      </div>\r\n      <div class=\"form-check\">\r\n        <input type=\"checkbox\" class=\"form-check-input\" id=\"urlNewTab\" formControlName=\"urlNewTab\">\r\n        <label class=\"form-check-label\" for=\"urlNewTab\">{{config.toolbarTitle['urlNewTab']}}</label>\r\n      </div>\r\n      <button type=\"submit\" class=\"btn-primary btn-sm btn\">{{config.toolbarTitle['linkSubmit']}}</button>\r\n    </form>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Image Uploader Popover template -->\r\n<ng-template #insertImageTemplate>\r\n  <div class=\"ngxe-popover imgc-ctnr\">\r\n    <div class=\"imgc-topbar btn-ctnr\">\r\n      <button type=\"button\" class=\"btn\" [ngClass]=\"{active: isImageUploader}\" (click)=\"isImageUploader = true\">\r\n        <fa-icon [icon]=\"icons.upload\"></fa-icon>\r\n      </button>\r\n      <button type=\"button\" class=\"btn\" [ngClass]=\"{active: !isImageUploader}\" (click)=\"isImageUploader = false\">\r\n        <fa-icon [icon]=\"icons.link\"></fa-icon>\r\n      </button>\r\n    </div>\r\n    <div class=\"imgc-ctnt is-image\">\r\n      <div *ngIf=\"isImageUploader; else insertImageLink\"> </div>\r\n      <div *ngIf=\"!isImageUploader; else imageUploder\"> </div>\r\n      <ng-template #imageUploder>\r\n        <div class=\"ngx-insert-img-ph\">\r\n          <p *ngIf=\"uploadComplete\">{{config.toolbarTitle['chooseImage']}}</p>\r\n          <p *ngIf=\"!uploadComplete\">\r\n            <span>{{config.toolbarTitle['uploadingimage']}}</span>\r\n            <br>\r\n            <span>{{ updloadPercentage }} %</span>\r\n          </p>\r\n          <div class=\"ngxe-img-upl-frm\">\r\n            <input type=\"file\" (change)=\"onFileChange($event)\" accept=\"image/*\" [disabled]=\"isUploading\" [style.cursor]=\"isUploading ? 'not-allowed': 'allowed'\">\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template #insertImageLink>\r\n        <form class=\"extra-gt\" [formGroup]=\"imageForm\" (ngSubmit)=\"imageForm.valid && insertImage()\" autocomplete=\"off\">\r\n          <div class=\"form-group\">\r\n            <label for=\"imageURLInput\" class=\"small\">{{config.toolbarTitle['imageURLInput']}}</label>\r\n            <input type=\"text\" class=\"form-control-sm\" id=\"imageURLInput\" placeholder=\"{{config.toolbarTitle['imageURLInput']}}\" formControlName=\"imageUrl\"\r\n              required>\r\n          </div>\r\n          <button type=\"submit\" class=\"btn-primary btn-sm btn\">{{config.toolbarTitle['imageSubmit']}}</button>\r\n        </form>\r\n      </ng-template>\r\n      <div class=\"progress\" *ngIf=\"!uploadComplete\">\r\n        <div class=\"progress-bar progress-bar-striped progress-bar-animated bg-success\" [ngClass]=\"{'bg-danger': updloadPercentage<20, 'bg-warning': updloadPercentage<50, 'bg-success': updloadPercentage>=100}\"\r\n          [style.width.%]=\"updloadPercentage\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n\r\n<!-- Insert Video Popover template -->\r\n<ng-template #insertVideoTemplate>\r\n  <div class=\"ngxe-popover imgc-ctnr\">\r\n    <div class=\"imgc-topbar btn-ctnr\">\r\n      <button type=\"button\" class=\"btn active\">\r\n        <fa-icon [icon]=\"icons.link\"></fa-icon>\r\n      </button>\r\n    </div>\r\n    <div class=\"imgc-ctnt is-image\">\r\n      <form class=\"extra-gt\" [formGroup]=\"videoForm\" (ngSubmit)=\"videoForm.valid && insertVideo()\" autocomplete=\"off\">\r\n        <div class=\"form-group\">\r\n          <label for=\"videoURLInput\" class=\"small\">{{config.toolbarTitle['videoURLInput']}}</label>\r\n          <input type=\"text\" class=\"form-control-sm\" id=\"videoURLInput\" placeholder=\"{{config.toolbarTitle['videoURLInput']}}\" formControlName=\"videoUrl\"\r\n            required>\r\n        </div>\r\n        <div class=\"row form-group\">\r\n          <div class=\"col\">\r\n            <input type=\"text\" class=\"form-control-sm\" formControlName=\"height\" placeholder=\"{{config.toolbarTitle['height']}}\" pattern=\"[0-9]\">\r\n          </div>\r\n          <div class=\"col\">\r\n            <input type=\"text\" class=\"form-control-sm\" formControlName=\"width\" placeholder=\"{{config.toolbarTitle['width']}}\" pattern=\"[0-9]\">\r\n          </div>\r\n          <label class=\"small\">{{config.toolbarTitle['heightwidth']}}</label>\r\n        </div>\r\n        <button type=\"submit\" class=\"btn-primary btn-sm btn\">{{config.toolbarTitle['videoSubmit']}}</button>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Insert color template -->\r\n<ng-template #insertColorTemplate>\r\n  <div class=\"ngxe-popover imgc-ctnr\">\r\n    <div class=\"imgc-topbar two-tabs\">\r\n      <span (click)=\"selectedColorTab ='textColor'\" [ngClass]=\"{active: selectedColorTab ==='textColor'}\">{{config.toolbarTitle['textColor']}}</span>\r\n      <span (click)=\"selectedColorTab ='backgroundColor'\" [ngClass]=\"{active: selectedColorTab ==='backgroundColor'}\">{{config.toolbarTitle['backgroundColor']}}</span>\r\n    </div>\r\n    <div class=\"imgc-ctnt is-color extra-gt1\">\r\n      <form autocomplete=\"off\">\r\n        <div class=\"form-group\">\r\n          <label for=\"hexInput\" class=\"small\">{{config.toolbarTitle['hexInput']}}</label>\r\n          <input type=\"text\" class=\"form-control-sm\" id=\"hexInput\" name=\"hexInput\" maxlength=\"7\" placeholder=\"{{config.toolbarTitle['hexInput']}}\"\r\n            [(ngModel)]=\"hexColor\" required>\r\n        </div>\r\n        <button type=\"button\" class=\"btn-primary btn-sm btn\" (click)=\"insertColor(hexColor, selectedColorTab)\">{{config.toolbarTitle['hexSubmit']}}</button>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- font size template -->\r\n<ng-template #fontSizeTemplate>\r\n  <div class=\"ngxe-popover extra-gt1\">\r\n    <form autocomplete=\"off\">\r\n      <div class=\"form-group\">\r\n        <label for=\"fontSize\" class=\"small\">{{config.toolbarTitle['fontSize']}}</label>\r\n        <input type=\"text\" class=\"form-control-sm\" id=\"fontSize\" name=\"fontSize\" placeholder=\"{{config.toolbarTitle['fontSize']}} (px/rem)\"\r\n          [(ngModel)]=\"fontSize\" required>\r\n      </div>\r\n      <button type=\"button\" class=\"btn-primary btn-sm btn\" (click)=\"setFontSize(fontSize)\">{{config.toolbarTitle['fontSubmit']}}</button>\r\n    </form>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- font family/name template -->\r\n<ng-template #fontNameTemplate>\r\n  <div class=\"ngxe-popover extra-gt1\">\r\n    <form autocomplete=\"off\">\r\n      <div class=\"form-group\">\r\n        <label for=\"fontSize\" class=\"small\">{{config.toolbarTitle['fontName']}}</label>\r\n        <input type=\"text\" class=\"form-control-sm\" id=\"fontSize\" name=\"fontName\" placeholder=\"{{config.toolbarTitle['example']}} 'Times New Roman', Times, serif\"\r\n          [(ngModel)]=\"fontName\" required>\r\n      </div>\r\n      <button type=\"button\" class=\"btn-primary btn-sm btn\" (click)=\"setFontName(fontName)\">{{config.toolbarTitle['fontSubmit']}}</button>\r\n    </form>\r\n  </div>\r\n</ng-template>\r\n", providers: [PopoverConfig], styles: ["::ng-deep .ngxePopover.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-style:normal;font-weight:400;line-height:1.5;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}::ng-deep .ngxePopover.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}::ng-deep .ngxePopover.popover .arrow::after,::ng-deep .ngxePopover.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}::ng-deep .ngxePopover.popover .popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}::ng-deep .ngxePopover.popover .popover-header:empty{display:none}::ng-deep .ngxePopover.popover .popover-body{padding:.5rem .75rem;color:#212529}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=top],::ng-deep .ngxePopover.popover.bs-popover-top{margin-bottom:.5rem}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow,::ng-deep .ngxePopover.popover.bs-popover-top .arrow{bottom:calc((.5rem + 1px) * -1)}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-top .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-top .arrow::before{border-width:.5rem .5rem 0}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-top .arrow::before{bottom:0;border-top-color:rgba(0,0,0,.25)}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=top] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-top .arrow::after{bottom:1px;border-top-color:#fff}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=right],::ng-deep .ngxePopover.popover.bs-popover-right{margin-left:.5rem}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow,::ng-deep .ngxePopover.popover.bs-popover-right .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-right .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-right .arrow::before{border-width:.5rem .5rem .5rem 0}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-right .arrow::before{left:0;border-right-color:rgba(0,0,0,.25)}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=right] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-right .arrow::after{left:1px;border-right-color:#fff}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom],::ng-deep .ngxePopover.popover.bs-popover-bottom{margin-top:.5rem}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow,::ng-deep .ngxePopover.popover.bs-popover-bottom .arrow{left:45%!important;top:calc((.5rem + 1px) * -1)}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-bottom .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-bottom .arrow::before{border-width:0 .5rem .5rem}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-bottom .arrow::before{top:0;border-bottom-color:rgba(0,0,0,.25)}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-bottom .arrow::after{top:1px;border-bottom-color:#fff}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=bottom] .popover-header::before,::ng-deep .ngxePopover.popover.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=left],::ng-deep .ngxePopover.popover.bs-popover-left{margin-right:.5rem}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow,::ng-deep .ngxePopover.popover.bs-popover-left .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-left .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-left .arrow::before{border-width:.5rem 0 .5rem .5rem}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::before,::ng-deep .ngxePopover.popover.bs-popover-left .arrow::before{right:0;border-left-color:rgba(0,0,0,.25)}::ng-deep .ngxePopover.popover.bs-popover-auto[x-placement^=left] .arrow::after,::ng-deep .ngxePopover.popover.bs-popover-left .arrow::after{right:1px;border-left-color:#fff}::ng-deep .ngxePopover .btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}::ng-deep .ngxePopover .btn.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}::ng-deep .ngxePopover .btn:active,::ng-deep .ngxePopover .btn:focus{outline:0;box-shadow:none}::ng-deep .ngxePopover .btn.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}::ng-deep .ngxePopover .btn.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}::ng-deep .ngxePopover .btn:not(:disabled):not(.disabled){cursor:pointer}::ng-deep .ngxePopover form .form-group{margin-bottom:1rem}::ng-deep .ngxePopover form .form-group input{overflow:visible}::ng-deep .ngxePopover form .form-group .form-control-sm{width:100%;outline:0;border:none;border-bottom:1px solid #bdbdbd;border-radius:0;margin-bottom:1px;padding:.25rem .5rem;font-size:.875rem;line-height:1.5}::ng-deep .ngxePopover form .form-group.row{display:flex;flex-wrap:wrap;margin-left:0;margin-right:0}::ng-deep .ngxePopover form .form-group.row .col{flex-basis:0;flex-grow:1;max-width:100%;padding:0}::ng-deep .ngxePopover form .form-group.row .col:first-child{padding-right:15px}::ng-deep .ngxePopover form .form-check{position:relative;display:block;padding-left:1.25rem}::ng-deep .ngxePopover form .form-check .form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.ngx-toolbar{display:flex;flex-wrap:wrap;background-color:#f5f5f5;font-size:.8rem;padding:.2rem .2rem 0;border:1px solid #ddd}.ngx-toolbar .ngx-toolbar-set{display:flex;border-radius:5px;background-color:#fff;margin-right:.2rem;margin-bottom:.2rem}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button{background-color:transparent;padding:.4rem;min-width:2.5rem;border:1px solid #ddd;border-right:transparent}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button .headerNumber{font-size:15px;top:1px;position:relative;left:1px;font-weight:700}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button:hover{cursor:pointer;background-color:#f1f1f1;transition:.2s}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button.focus,.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button:focus{outline:0}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button:last-child{border-right:1px solid #ddd;border-top-right-radius:5px;border-bottom-right-radius:5px}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.ngx-toolbar .ngx-toolbar-set .ngx-text-editor-button:disabled{background-color:#f5f5f5;pointer-events:none;cursor:not-allowed}::ng-deep .popover{border-top-right-radius:0;border-top-left-radius:0}::ng-deep .ngxe-popover{min-width:15rem;white-space:nowrap}::ng-deep .ngxe-popover .extra-gt,::ng-deep .ngxe-popover.extra-gt{padding-top:.5rem!important}::ng-deep .ngxe-popover .extra-gt1,::ng-deep .ngxe-popover.extra-gt1{padding-top:.75rem!important}::ng-deep .ngxe-popover .extra-gt2,::ng-deep .ngxe-popover.extra-gt2{padding-top:1rem!important}::ng-deep .ngxe-popover .form-group label{display:none;margin:0}::ng-deep .ngxe-popover .form-group .form-control-sm{width:100%;outline:0;border:none;border-bottom:1px solid #bdbdbd;border-radius:0;margin-bottom:1px;padding-left:0;padding-right:0}::ng-deep .ngxe-popover .form-group .form-control-sm:active,::ng-deep .ngxe-popover .form-group .form-control-sm:focus{border-bottom:2px solid #1e88e5;box-shadow:none;margin-bottom:0}::ng-deep .ngxe-popover .form-group .form-control-sm.ng-dirty.ng-invalid:not(.ng-pristine){border-bottom:2px solid red}::ng-deep .ngxe-popover .form-check{margin-bottom:1rem}::ng-deep .ngxe-popover .btn:focus{box-shadow:none!important}::ng-deep .ngxe-popover.imgc-ctnr{margin:-.5rem -.75rem}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);border-bottom:0}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar.btn-ctnr button{background-color:transparent;border-radius:0}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar.btn-ctnr button:hover{cursor:pointer;background-color:#f1f1f1;transition:.2s}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar.btn-ctnr button.active{color:#007bff;transition:.2s}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar.two-tabs span{width:50%;display:inline-flex;justify-content:center;padding:.4rem 0;margin:0 -1px 2px}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar.two-tabs span:hover{cursor:pointer}::ng-deep .ngxe-popover.imgc-ctnr .imgc-topbar.two-tabs span.active{margin-bottom:-2px;border-bottom:2px solid #007bff;color:#007bff}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt{padding:.5rem}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .progress{height:.5rem;margin:.5rem -.5rem -.6rem}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image p{margin:0}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph{border:2px dashed #bdbdbd;padding:1.8rem 0;position:relative;letter-spacing:1px;text-align:center}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph:hover{background:#ebebeb}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph .ngxe-img-upl-frm{opacity:0;position:absolute;top:0;bottom:0;left:0;right:0;z-index:2147483640;overflow:hidden;margin:0;padding:0;width:100%}::ng-deep .ngxe-popover.imgc-ctnr .imgc-ctnt.is-image .ngx-insert-img-ph .ngxe-img-upl-frm input{cursor:pointer;position:absolute;right:0;top:0;bottom:0;margin:0}"] }]
    }], function () { return [{ type: ɵngcc3.PopoverConfig }, { type: ɵngcc4.FormBuilder }, { type: MessageService }, { type: CommandExecutorService }]; }, { execute: [{
            type: Output
        }], uploadImage: [{
            type: Output
        }], config: [{
            type: Input
        }], urlPopover: [{
            type: ViewChild,
            args: ['urlPopover', { static: true }]
        }], imagePopover: [{
            type: ViewChild,
            args: ['imagePopover', { static: true }]
        }], videoPopover: [{
            type: ViewChild,
            args: ['videoPopover', { static: true }]
        }], fontSizePopover: [{
            type: ViewChild,
            args: ['fontSizePopover', { static: true }]
        }], colorPopover: [{
            type: ViewChild,
            args: ['colorPopover', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTextEditorModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxTextEditorComponent,
                    NgxGrippieComponent,
                    NgxTextEditorMessageComponent,
                    NgxTextEditorToolbarComponent
                ],
                exports: [
                    NgxTextEditorComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    PopoverModule.forRoot(),
                    ReactiveFormsModule,
                    FontAwesomeModule
                ],
                providers: [
                    CommandExecutorService,
                    MessageService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxTextEditorModule, { declarations: function () { return [NgxTextEditorComponent, NgxGrippieComponent, NgxTextEditorMessageComponent, NgxTextEditorToolbarComponent]; }, imports: function () { return [CommonModule,
        FormsModule, ɵngcc3.PopoverModule, ReactiveFormsModule,
        FontAwesomeModule]; }, exports: function () { return [NgxTextEditorComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTextEditorModule, NgxTextEditorComponent as ɵa, MessageService as ɵb, CommandExecutorService as ɵc, NgxGrippieComponent as ɵd, NgxTextEditorMessageComponent as ɵe, NgxTextEditorToolbarComponent as ɵf };

